var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// js/sections/announcement-bar.js
import { timeline } from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
import { EffectCarousel } from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var AnnouncementBar = class extends EffectCarousel {
  _transitionTo(fromSlide, toSlide) {
    timeline([
      [
        fromSlide,
        { transform: ["translateY(0)", "translateY(-5px)"], opacity: [1, 0], visibility: ["visible", "hidden"] },
        { duration: 0.2 },
      ],
      [
        toSlide,
        { transform: ["translateY(5px)", "translateY(0)"], opacity: [0, 1], visibility: ["hidden", "visible"] },
        { duration: 0.2 },
      ],
    ]);
  }
};
if (!window.customElements.get("announcement-bar")) {
  window.customElements.define("announcement-bar", AnnouncementBar);
}

// js/sections/before-after-image.js
var SplitCursor = class extends HTMLElement {
  connectedCallback() {
    this._parentSection = this.closest(".shopify-section");
    this._dragging = false;
    this._offsetX = this._currentX = 0;
    this._parentSection.addEventListener("pointerdown", this._onPointerDown.bind(this));
    this._parentSection.addEventListener("pointermove", this._onPointerMove.bind(this));
    this._parentSection.addEventListener("pointerup", this._onPointerUp.bind(this));
    this._recalculateOffset();
    window.addEventListener("resize", this._recalculateOffset.bind(this));
  }
  get minOffset() {
    return -this.offsetLeft - (document.dir === "rtl" ? this.clientWidth : 0);
  }
  get maxOffset() {
    return this.offsetParent.clientWidth + this.minOffset;
  }
  _onPointerDown(event) {
    if (event.target === this || this.contains(event.target)) {
      this._initialX = event.clientX - this._offsetX;
      this._dragging = true;
    }
  }
  _onPointerMove(event) {
    if (!this._dragging) {
      return;
    }
    this._currentX = Math.min(Math.max(event.clientX - this._initialX, this.minOffset), this.maxOffset);
    this._offsetX = this._currentX;
    this._parentSection.style.setProperty("--clip-path-offset", `${this._currentX.toFixed(1)}px`);
  }
  _onPointerUp() {
    this._dragging = false;
  }
  _recalculateOffset() {
    this._parentSection.style.setProperty(
      "--clip-path-offset",
      `${Math.min(Math.max(this.minOffset, this._currentX.toFixed(1)), this.maxOffset)}px`,
    );
  }
};
if (!window.customElements.get("split-cursor")) {
  window.customElements.define("split-cursor", SplitCursor);
}

// js/sections/collection-list.js
import { timeline as timeline2, inView } from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
var CollectionList = class extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView(this, this._reveal.bind(this), { margin: "-100px" });
    }
  }
  _reveal() {
    const toReveal = Array.from(this.querySelectorAll("[reveal-js]"));
    timeline2([
      [toReveal, { opacity: 1 }, { duration: 0 }],
      [
        toReveal.map((item) => item.querySelector("img, svg")),
        { opacity: [0, 1], transform: ["scale(1.03)", "auto"] },
        { duration: 0.2 },
      ],
      [
        toReveal.map((item) => item.querySelector(".collection-card__content-wrapper")),
        { opacity: [0, 1] },
        { duration: 0.2 },
      ],
    ]);
  }
};
if (!window.customElements.get("collection-list")) {
  window.customElements.define("collection-list", CollectionList);
}

// js/sections/customer-login.js
import { Delegate } from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
var AccountLogin = class extends HTMLElement {
  connectedCallback() {
    this.recoverForm = this.querySelector("#recover");
    this.loginForm = this.querySelector("#login");
    if (window.location.hash.includes("#recover")) {
      this._switchForms();
    }
    if (window.location.search && window.location.search.includes("activeUrl=")) {
      this._activeUrl();
    }
    new Delegate(this).on("click", '[href="#recover"], [href="#login"]', this._switchForms.bind(this));
  }
  _switchForms(event) {
    if (event) {
      event.preventDefault();
    }
    this.recoverForm.hidden = !this.recoverForm.hidden;
    this.loginForm.hidden = !this.loginForm.hidden;
    window.A11yLinkKeyboard?.scanCustomerAccountForms?.(this);
  }
  _activeUrl(event) {
    if (event) {
      event.preventDefault();
    }
    this.checkout_url = this.querySelector('input[name="checkout_url"]');
    this.checkout_url.value = this.getUrlParameter("activeUrl");
  }
  getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(window.location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
};
if (!window.customElements.get("account-login")) {
  window.customElements.define("account-login", AccountLogin);
}

// js/sections/header.js
import { animate, timeline as timeline3, stagger, Delegate as Delegate2 } from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
import {
  AnimatedDetails,
  EffectCarousel as EffectCarousel2,
  Drawer,
  throttle,
  bindFocusActivate,
} from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var reduceMenuAnimation = JSON.parse("false");
var StoreHeader = class extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute("hide-on-scroll") && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      this._lastScrollTop = 0;
      this._accumulatedScroll = 0;
      this._isVisible = true;
      this._hasSwitchedToSticky = false;
      window.addEventListener("scroll", throttle(this._onScroll.bind(this)));
    }
    this.addEventListener("toggle", this._checkTransparency.bind(this), { capture: true });
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        this.classList.remove("is-filled");
        this._setupTransparentHeader();
      }
    });
    this._setupTransparentHeader();
    if (this.hasAttribute("sticky")) {
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", this._setupTransparentHeader.bind(this));
        document.addEventListener("shopify:section:unload", this._setupTransparentHeader.bind(this));
        document.addEventListener("shopify:section:reorder", this._setupTransparentHeader.bind(this));
      }
    }
  }
  hide() {
    if (this._isVisible) {
      animate(this, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.2, easing: "ease" });
      this._isVisible = false;
    }
  }
  show() {
    if (!this._isVisible) {
      animate(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.2, easing: "ease" });
      this._accumulatedScroll = 0;
      this._isVisible = true;
    }
  }
  _onScroll() {
    if (window.scrollY < 0) {
      return;
    }
    this._accumulatedScroll = Math.max(0, this._accumulatedScroll + (window.scrollY - this._lastScrollTop));
    if (window.scrollY < this._lastScrollTop) {
      this.show();
    } else if (this._accumulatedScroll > parseInt(this.getAttribute("hide-on-scroll"))) {
      this.hide();
    }
    this._lastScrollTop = window.scrollY;
  }
  _checkTransparency() {
    let hasFallbackScrollDetection = false;
    if (
      CSS.supports("selector(:has(> *))") &&
      this.hasAttribute("sticky") &&
      !this.hasAttribute("hide-on-scroll") &&
      this.hasAttribute("allow-transparency")
    ) {
      const offsetBeforeChanging = 500;
      if (this.querySelectorAll("[open]").length > 0) {
        this.classList.add("is-filled");
      } else if (window.scrollY >= offsetBeforeChanging && !this._hasSwitchedToSticky) {
        this._hasSwitchedToSticky = true;
        this.classList.add("is-filled");
        animate(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.15, easing: "ease" });
      } else if (window.scrollY < offsetBeforeChanging) {
        if (this._hasSwitchedToSticky) {
          this._hasSwitchedToSticky = false;
          animate(
            this,
            { transform: ["translateY(0)", "translateY(-100%)"] },
            { duration: 0.15, easing: "ease" },
          ).finished.then(() => {
            this.style.transform = null;
            this.classList.remove("is-filled");
          });
        } else if (this.getAnimations().length === 0) {
          this.classList.remove("is-filled");
        }
      }
    } else {
      hasFallbackScrollDetection = window.scrollY > 20;
      this.classList.toggle(
        "is-filled",
        !this.hasAttribute("allow-transparency") ||
          this.querySelectorAll("[open]").length > 0 ||
          hasFallbackScrollDetection,
      );
    }
  }
  _setupTransparentHeader() {
    if (document.querySelector(".shopify-section:first-child [allow-transparent-header]")) {
      this.setAttribute("allow-transparency", "");
      this.addEventListener("mouseenter", this._checkTransparency.bind(this));
      this.addEventListener("mouseleave", this._checkTransparency.bind(this));
      if (this.hasAttribute("sticky")) {
        window.addEventListener("scroll", throttle(this._checkTransparency.bind(this)));
      }
      this._checkTransparency();
    } else {
      this.removeAttribute("allow-transparency");
    }
  }
};
var DropdownDisclosure = class _DropdownDisclosure extends AnimatedDetails {
  constructor() {
    super();
    this._detectClickOutsideListener = this._detectClickOutside.bind(this);
    this._detectEscKeyboardListener = this._detectEscKeyboard.bind(this);
    this._detectFocusOutListener = this._detectFocusOut.bind(this);
    this._detectHoverListener = this._detectHover.bind(this);
    this._detectFocusInListener = this._detectFocusIn.bind(this);
    this._hoverTimer = null;
    this._focusOutTimer = null;
    this._isClosing = false;
    this._reopenAfterClose = false;
    this._onSummaryKeydown = this._onSummaryKeydown.bind(this);
    this.addEventListener("mouseover", this._detectHoverListener.bind(this));
    this.addEventListener("mouseout", this._detectHoverListener.bind(this));
    bindFocusActivate(this.summaryElement, this._detectFocusInListener);
    this.summaryElement.addEventListener("keydown", this._onSummaryKeydown);
    this.addEventListener("focusin", (event) => {
      clearTimeout(this._focusOutTimer);
      if (this.trigger !== "hover" && this.trigger !== "click") {
        return;
      }
      if (event.target === this.summaryElement || event.target.closest?.("summary") === this.summaryElement) {
        this._detectFocusIn();
      }
    });
  }
  get trigger() {
    return !window.matchMedia("screen and (pointer: fine)").matches ? "click" : this.getAttribute("trigger");
  }
  get mouseOverDelayTolerance() {
    return 250;
  }
  /**
   * When the summary is clicked and that the mode is hover, we follow the link (if set) that may have been specified
   * on the parent. If the mode is click, then we deferred to the default behavior of the "AnimatedDetails" parent
   */
  _isKeyboardSummaryActivation(event) {
    if (event instanceof KeyboardEvent) {
      return true;
    }
    if (event.detail === 0) {
      return true;
    }
    if (event.pointerType === "" || event.pointerType === "none") {
      return true;
    }
    return false;
  }
  _onSummaryClicked(event) {
    if (this.trigger === "hover") {
      event.preventDefault();
      if (this._isKeyboardSummaryActivation(event)) {
        this.open = !this.open;
        return;
      }
      if (event.currentTarget.hasAttribute("data-url")) {
        window.location.href = event.currentTarget.getAttribute("data-url");
      }
    } else {
      super._onSummaryClicked(event);
    }
  }
  async _transition(value) {
    if (value) {
      this._isClosing = false;
      this._reopenAfterClose = false;
      this.setAttribute("open", "");
      document.addEventListener("click", this._detectClickOutsideListener);
      document.addEventListener("keydown", this._detectEscKeyboardListener);
      document.addEventListener("focusout", this._detectFocusOutListener);
      const openSiblings = Array.from(this.closest("ul").querySelectorAll("[open]")).filter((item) => item !== this);
      openSiblings.forEach((sibling) => (sibling.open = false));
      await this._transitionIn(openSiblings.length > 0);
    } else {
      this._isClosing = true;
      document.removeEventListener("click", this._detectClickOutsideListener);
      document.removeEventListener("keydown", this._detectEscKeyboardListener);
      document.removeEventListener("focusout", this._detectFocusOutListener);
      await this._transitionOut();
      this.removeAttribute("open");
      this._isClosing = false;
      if (this._reopenAfterClose) {
        this._reopenAfterClose = false;
        this.open = true;
      }
    }
  }
  _transitionIn(hasOpenSiblings = false) {
    const timelineSequence = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }]];
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      timelineSequence.push([
        this.contentElement.querySelectorAll(":scope > ul > li"),
        { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] },
        { delay: stagger(0.025), at: "-0.1", duration: 0.2 },
      ]);
    }
    return timeline3(timelineSequence, { delay: hasOpenSiblings > 0 ? 0.1 : 0 }).finished.then(() => {
      if (this.contentElement) {
        this.contentElement.style.opacity = "1";
      }
    });
  }
  _transitionOut() {
    return timeline3([[this.contentElement, { opacity: 0 }, { duration: 0.2 }]]).finished;
  }
  /**
   * When dropdown menu is configured to open on click, we add a listener to detect click outside and automatically
   * close the navigation.
   */
  _detectClickOutside(event) {
    if (this.trigger !== "click") {
      return;
    }
    if (!this.contains(event.target) && !(event.target.closest("details") instanceof _DropdownDisclosure)) {
      this.open = false;
    }
  }
  /**
   * Open dropdown when summary receives keyboard focus (mirrors hover behavior).
   */
  _detectFocusIn() {
    if (this.trigger !== "hover" && this.trigger !== "click") {
      return;
    }
    if (this._isClosing) {
      this._reopenAfterClose = true;
      return;
    }
    clearTimeout(this._hoverTimer);
    this.open = true;
  }
  _onSummaryKeydown(event) {
    if (event.key !== "Enter" && event.key !== " " && event.key !== "ArrowDown") {
      return;
    }
    event.stopPropagation();

    if (this.trigger === "click") {
      if (event.key === "ArrowDown") {
        event.preventDefault();
        if (!this.open) {
          this.open = true;
        }
        this.contentElement?.querySelector("a, button:not([disabled])")?.focus();
        return;
      }
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.open = !this.open;
      }
      return;
    }

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.open = true;
      return;
    }

    if (event.key === "ArrowDown") {
      event.preventDefault();
      this.open = true;
      this.contentElement?.querySelector("a, button:not([disabled])")?.focus();
    }
  }
  /**
   * On desktop device, if the mode is set to hover, we open/close the dropdown on hover
   */
  _detectHover(event) {
    if (this.trigger !== "hover") {
      return;
    }
    if (event.type === "mouseover") {
      if (this._isClosing) {
        this._reopenAfterClose = true;
        return;
      }
      this.open = true;
      clearTimeout(this._hoverTimer);
    } else {
      this._hoverTimer = setTimeout(() => (this.open = false), this.mouseOverDelayTolerance);
    }
  }
  /**
   * Detect if we hit the "Escape" key to automatically close the dropdown
   */
  _detectEscKeyboard(event) {
    if (event.code === "Escape") {
      const targetMenu = event.target.closest("details[open]");
      if (targetMenu) {
        targetMenu.open = false;
      }
    }
  }
  /**
   * Close the dropdown automatically when the dropdown is focused out
   */
  _detectFocusOut(event) {
    clearTimeout(this._focusOutTimer);
    this._focusOutTimer = setTimeout(() => {
      const nextFocus = event.relatedTarget || document.activeElement;
      if (nextFocus && this.contains(nextFocus)) {
        return;
      }
      if (!this.contains(document.activeElement)) {
        this.open = false;
      }
    }, 150);
  }
};
var MegaMenuDisclosure = class extends DropdownDisclosure {
  constructor() {
    super();
    this.addEventListener("pointerover", this._preloadImages.bind(this));
    this._onMegaMenuTabBound = this._onMegaMenuTab.bind(this);
    this.addEventListener("keydown", this._onMegaMenuTabBound);
  }
  _isDesktopHeaderNav() {
    return window.matchMedia("(min-width: 1280px)").matches;
  }
  _getMegaMenuFocusables() {
    const focusables = [this.summaryElement];
    if (!this.contentElement || !this.open) {
      return focusables;
    }
    const links = Array.from(
      this.contentElement.querySelectorAll('a[href]:not([hidden]), button:not([disabled]):not([hidden])'),
    ).filter((el) => el.getClientRects().length > 0);
    return focusables.concat(links);
  }
  _getHeaderNavFocusables() {
    const nav = this.closest(".header__link-list");
    if (!nav) {
      return [];
    }
    return Array.from(
      nav.querySelectorAll(
        'summary, a.link-faded-reverse[href], a.bold.link-faded-reverse[href], li > a.link-faded-reverse[href]',
      ),
    ).filter((el) => el.getClientRects().length > 0 && el.getAttribute("tabindex") !== "-1");
  }
  _focusHeaderNavSibling(forward) {
    const candidates = this._getHeaderNavFocusables();
    const currentSummary = this.summaryElement;
    const summaryIndex = candidates.indexOf(currentSummary);
    if (summaryIndex === -1) {
      return false;
    }
    const targetIndex = forward ? summaryIndex + 1 : summaryIndex - 1;
    const target = candidates[targetIndex];
    if (!target) {
      return false;
    }
    target.focus();
    return true;
  }
  _onMegaMenuTab(event) {
    if (event.key !== "Tab" || !this._isDesktopHeaderNav()) {
      return;
    }
    if (!this.open) {
      return;
    }
    const order = this._getMegaMenuFocusables();
    const active = document.activeElement;
    const index = order.indexOf(active);
    if (index === -1) {
      return;
    }
    const nextIndex = event.shiftKey ? index - 1 : index + 1;
    if (nextIndex >= 0 && nextIndex < order.length) {
      event.preventDefault();
      order[nextIndex].focus();
      return;
    }
    if (!event.shiftKey && index === order.length - 1) {
      event.preventDefault();
      this.open = false;
      this._focusHeaderNavSibling(true);
      return;
    }
    if (event.shiftKey && index === 0) {
      event.preventDefault();
      this.open = false;
      this._focusHeaderNavSibling(false);
    }
  }
  get mouseOverDelayTolerance() {
    return 250;
  }
  _usesNewHeaderMegaMenu() {
    return (
      this._isDesktopHeaderNav() && this.contentElement?.classList?.contains("new-mega-menu-260408")
    );
  }
  _transitionIn(hasOpenSiblings) {
    if (this._usesNewHeaderMegaMenu()) {
      if (this.contentElement) {
        this.contentElement.style.opacity = "1";
      }
      return Promise.resolve();
    }
    const timelineSequence = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }], "mega-menu"],
      contentDelay = hasOpenSiblings ? 0.1 : 0;
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      this.contentElement.querySelectorAll(".mega-menu__promo").forEach((promo) => {
        timelineSequence.push(
          [promo, { opacity: [0, 1] }, { duration: 0.25, delay: contentDelay, at: "mega-menu" }],
          "mega-menu-promo",
        );
      });
      this.contentElement.querySelectorAll(".mega-menu__nav > li").forEach((column) => {
        timelineSequence.push([
          column.querySelectorAll(":scope > :first-child, :scope li"),
          { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] },
          { easing: "ease", delay: stagger(0.025, { start: contentDelay }), at: "mega-menu", duration: 0.2 },
        ]);
      });
    }
    return timeline3(timelineSequence).finished.then(() => {
      if (this.contentElement) {
        this.contentElement.style.opacity = "1";
      }
    });
  }
  _transitionOut() {
    if (this._usesNewHeaderMegaMenu()) {
      if (this.contentElement) {
        this.contentElement.style.removeProperty("opacity");
      }
      return Promise.resolve();
    }
    return super._transitionOut();
  }
  /**
   * When the toggle is hovered we preload the mega-menu images to improve perceived performance
   */
  _preloadImages() {
    Array.from(this.querySelectorAll('img[loading="lazy"]')).forEach((image) => image.setAttribute("loading", "eager"));
  }
};
var MegaMenuPromoCarousel = class extends EffectCarousel2 {
  connectedCallback() {
    super.connectedCallback();
    if (this.nextElementSibling) {
      this.addEventListener("carousel:select", (event) => this._updateControlsColor(event.detail.slide));
    }
    this._updateControlsColor(this.items[this.selectedIndex]);
  }
  _updateControlsColor(slide) {
    const extractFrom = slide.classList.contains("content-over-media") ? slide : slide.firstElementChild;
    this.nextElementSibling.style.setProperty("--text-color", extractFrom.style.getPropertyValue("--text-color"));
  }
};
var NavigationDrawer = class extends Drawer {
  constructor() {
    super();
    const delegate = new Delegate2(this);
    delegate.on("click", "button[data-panel]", this._onPanelButtonClick.bind(this));
    this._isTransitioning = false;
    this.addEventListener("dialog:after-hide", () => {
      this.reinitializeDrawer();
    });
  }
  get openFrom() {
    return window.matchMedia("(max-width: 699px)").matches ? this.getAttribute("mobile-opening") : super.openFrom;
  }
  // Used for navigation mobile and navigation desktop set to drawer
  switchToPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let panelToHideTransform,
      panelToShowTransform,
      panelToHide = linkListIndex !== null ? panels[parseInt(panelIndex) - 1] : panels[parseInt(panelIndex) + 1],
      panelToShow = panels[panelIndex],
      linkLists = panelToShow.querySelectorAll(".panel__wrapper"),
      timelineSequence = [];
    if (document.dir === "rtl") {
      panelToHideTransform =
        linkListIndex !== null ? ["translateX(0%)", "translateX(100%)"] : ["translateX(0%)", "translateX(-100%)"];
      panelToShowTransform =
        linkListIndex !== null ? ["translateX(-100%)", "translateX(0%)"] : ["translateX(100%)", "translateX(0%)"];
    } else {
      panelToHideTransform =
        linkListIndex !== null ? ["translateX(0%)", "translateX(-100%)"] : ["translateX(0%)", "translateX(100%)"];
      panelToShowTransform =
        linkListIndex !== null ? ["translateX(100%)", "translateX(0%)"] : ["translateX(-100%)", "translateX(0%)"];
    }
    timelineSequence.push(
      [
        panelToHide,
        { transform: panelToHideTransform, opacity: [1, 0], visibility: ["visible", "hidden"] },
        { duration: 0.3, opacity: { at: "+0.3" }, transform: { at: "+0.3" } },
      ],
      "panelHidden",
      [
        panelToShow,
        { opacity: [0, 1], visibility: ["hidden", "visible"], transform: panelToShowTransform },
        { at: "<", transform: { duration: 0.3 } },
      ],
    );
    if (linkListIndex !== null) {
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }
    timeline3(timelineSequence);
  }
  // Used when mega menu is set to drawer
  showPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let timelineSequence = [],
      panelToShow = panels[panelIndex],
      linkLists = panelToShow.querySelectorAll(".panel__wrapper");
    if (!panelToShow.hasAttribute("open") && !this._isTransitioning) {
      this._isTransitioning = true;
      timelineSequence.push(
        [
          this,
          {
            width: [
              this.offsetWidth + "px",
              (this.offsetWidth - parseInt(window.getComputedStyle(this).getPropertyValue("padding"))) * 2 + "px",
            ],
          },
          { duration: 0.2 },
        ],
        [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" }],
      );
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }
    if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
      timelineSequence.push([
        linkLists[this.previousLinkIndex],
        { opacity: [1, 0], visibility: ["visible", "hidden"] },
        { duration: 0.2 },
      ]);
    }
    timeline3(timelineSequence).finished.then(() => {
      if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
        linkLists[this.previousLinkIndex].removeAttribute("style");
      }
      if (panelToShow.hasAttribute("open") && this.previousLinkIndex !== linkListIndex) {
        timeline3([this.switchLinkList(linkLists, linkListIndex)]);
      }
      this.previousLinkIndex = linkListIndex;
      panelToShow.setAttribute("open", "");
      this._isTransitioning = false;
    });
  }
  switchLinkList(linkLists, linkListIndex) {
    Array.from(linkLists).forEach((item) => {
      item.setAttribute("hidden", "");
    });
    linkLists[linkListIndex].removeAttribute("hidden");
    return [
      linkLists[linkListIndex].querySelectorAll("li"),
      { opacity: [0, 1], visibility: ["hidden", "visible"], transform: ["translateY(-10px)", "translateY(0)"] },
      { easing: "ease", duration: 0.2, at: "-0.15", delay: stagger(0.025, { start: 0.1 }) },
    ];
  }
  // Set navigation drawer to initial state when drawer closed
  reinitializeDrawer() {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.style.removeProperty("width");
      this.setExpanded();
    } else {
      const firstPanel = this.querySelector(".panel:first-child");
      firstPanel.style.opacity = "1";
      firstPanel.style.visibility = "visible";
      firstPanel.style.transform = "translateX(0%)";
    }
    Array.from(this.querySelectorAll(".panel:not(:first-child)")).forEach((item) => {
      if (this.hasAttribute("mega-menu")) {
        item.removeAttribute("open");
      }
      item.style.opacity = "0";
      item.style.visibility = "hidden";
      Array.from(item.querySelectorAll(".panel__wrapper")).forEach((list) => list.setAttribute("hidden", ""));
    });
  }
  setExpanded(target) {
    Array.from(this.querySelectorAll("button[data-panel]")).forEach((item) => {
      item.setAttribute("aria-expanded", "false");
      let id = item.id.split("_")[1];
      let is_mega_menu_id = "#is_mega_menu_" + id;
      let is_mega_menu = this.querySelector(is_mega_menu_id);
      if (is_mega_menu) {
        is_mega_menu.hidden = true;
      }
    });
    if (target) {
      target.setAttribute("aria-expanded", "true");
      let id = target.id.split("_")[1];
      let is_mega_menu_id = "#is_mega_menu_" + id;
      let is_mega_menu = this.querySelector(is_mega_menu_id);
      if (is_mega_menu) {
        is_mega_menu.hidden = false;
      }
    }
  }
  _onPanelButtonClick(event, target) {
    let id = target.id.split("_")[1];
    let is_mega_menu_id = "#is_mega_menu_" + id;
    let is_mega_menu = this.querySelector(is_mega_menu_id);
    if (is_mega_menu && is_mega_menu.hidden) {
      this.setExpanded(target);
    } else {
      this.setExpanded();
    }
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.setExpanded(target);
      // this.showPanel(...target.getAttribute("data-panel").split("-"));
    } else {
      // this.switchToPanel(...target.getAttribute("data-panel").split("-"));
    }
  }
};
if (!window.customElements.get("store-header")) {
  window.customElements.define("store-header", StoreHeader);
}
if (!window.customElements.get("dropdown-disclosure")) {
  window.customElements.define("dropdown-disclosure", DropdownDisclosure, { extends: "details" });
}
if (!window.customElements.get("mega-menu-disclosure")) {
  window.customElements.define("mega-menu-disclosure", MegaMenuDisclosure, { extends: "details" });
}
if (!window.customElements.get("mega-menu-promo-carousel")) {
  window.customElements.define("mega-menu-promo-carousel", MegaMenuPromoCarousel);
}
if (!window.customElements.get("navigation-drawer")) {
  window.customElements.define("navigation-drawer", NavigationDrawer);
}

// js/sections/feature-chart.js
import { animate as motionAnimate, scroll } from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
import { bindScrollRegionA11y } from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var FeatureChart = class extends HTMLElement {
  connectedCallback() {
    this.viewButtonElement = this.querySelector('[data-action="toggle-rows"]');
    this.featureChartTable = this.querySelector(".feature-chart__table");
    this.featureChartRows = Array.from(this.featureChartTable.childNodes);
    this.featureProductRow = this.querySelector(".feature-chart__table-row--product");
    this.featureChartSticky = this.querySelector(".feature-chart__table-row--sticky");
    if (this.viewButtonElement) {
      this.viewButtonElement.addEventListener("click", this._toggleRows.bind(this));
    }
    if (this.featureChartTable) {
      bindScrollRegionA11y(this.featureChartTable);
      this.featureChartTable.setAttribute(
        "data-a11y-label",
        this.getAttribute("data-a11y-label") || "Feature comparison",
      );
    }
    window.A11yLinkKeyboard?.scan?.(this);
    this._syncStickyRowTabStops();
    if (this.featureChartSticky) {
      this.featureChartSticky.style.width = `${this.featureChartTable.scrollWidth}px`;
      this.featureChartTable.addEventListener("scroll", (event) => {
        this.featureChartSticky.style.marginLeft = -1 * event.target.scrollLeft + "px";
      });
      new ResizeObserver((entries) => {
        this.featureChartSticky.style.width = `${entries[0].contentRect.width}px`;
      }).observe(this.featureChartTable);
      const offset = getComputedStyle(this).scrollPaddingTop;
      scroll(
        ({ y }) => {
          if (y.current >= y.targetOffset + this.featureProductRow.clientHeight / 2 && y.progress < 0.85) {
            this.featureChartSticky.classList.add("is-visible");
          } else {
            this.featureChartSticky.classList.remove("is-visible");
          }
          this._syncStickyRowTabStops();
        },
        {
          target: this.featureChartTable,
          offset: [`${offset} start`, `end ${offset}`],
        },
      );
    }
  }
  _toggleRows() {
    if (this.classList.contains("is-expanded")) {
      this._hideRows();
    } else {
      this._showRows();
    }
  }
  _syncStickyRowTabStops() {
    const sticky = this.featureChartSticky;
    if (!sticky) {
      return;
    }
    const tabbable = sticky.classList.contains("is-visible");
    sticky.querySelectorAll("a[href], button").forEach((control) => {
      if (tabbable) {
        control.removeAttribute("data-a11y-no-tab");
        control.setAttribute("tabindex", "0");
      } else {
        control.setAttribute("data-a11y-no-tab", "true");
        control.setAttribute("tabindex", "-1");
      }
    });
    if (tabbable) {
      window.A11yLinkKeyboard?.scan?.(this);
    }
  }
  async _showRows() {
    const fromHeight = this.featureChartTable.clientHeight;
    this.featureChartRows.forEach((row) => {
      row.hidden = false;
    });
    this.viewButtonElement.querySelector(".feature-chart__toggle-text").innerText =
      this.viewButtonElement.getAttribute("data-view-less");
    this.classList.add("is-expanded");
    if (this.viewButtonElement) {
      this.viewButtonElement.setAttribute("aria-expanded", "true");
    }
    await motionAnimate(this.featureChartTable, {
      height: [`${fromHeight}px`, `${this.featureChartTable.clientHeight}px`],
    }).finished;
    this.featureChartTable.style.height = "auto";
  }
  async _hideRows() {
    let fromHeight = this.featureChartTable.clientHeight,
      toHeight = 0;
    this.featureChartRows.slice(0, parseInt(this.getAttribute("max-rows"))).forEach((row) => {
      toHeight += row.clientHeight;
    });
    this.viewButtonElement.querySelector(".feature-chart__toggle-text").innerText =
      this.viewButtonElement.getAttribute("data-view-more");
    this.classList.remove("is-expanded");
    if (this.viewButtonElement) {
      this.viewButtonElement.setAttribute("aria-expanded", "false");
    }
    await motionAnimate(this.featureChartTable, { height: [`${fromHeight}px`, `${toHeight}px`] }).finished;
    this.featureChartRows.slice(parseInt(this.getAttribute("max-rows"))).forEach((row) => (row.hidden = true));
    this.featureChartTable.style.height = "auto";
  }
};
if (!window.customElements.get("feature-chart")) {
  window.customElements.define("feature-chart", FeatureChart);
}

// js/sections/image-banner.js
import {
  scroll as scroll2,
  timeline as timeline4,
  animate as animate2,
  inView as inView2,
} from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
import { imageLoaded, getHeadingKeyframe } from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var ImageBanner = class extends HTMLElement {
  connectedCallback() {
    if (this.parallax && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      this._setupParallax();
    }
    inView2(this, async () => {
      await imageLoaded(Array.from(this.querySelectorAll(":scope > :is(img, video, iframe, svg, video-media)")));
      const headings = Array.from(this.querySelectorAll('[reveal-on-scroll="true"]'));
      timeline4([
        [this, { opacity: [0, 1] }, { duration: 0.25 }],
        ...headings.map((heading) => [...getHeadingKeyframe(heading)]),
      ]);
    });
  }
  get parallax() {
    return this.hasAttribute("parallax") ? parseFloat(this.getAttribute("parallax")) : false;
  }
  _setupParallax() {
    const media = Array.from(this.querySelectorAll(":scope > :is(img, video, iframe, svg, video-media)")),
      [scale, translate] = [1 + this.parallax, (this.parallax * 100) / (1 + this.parallax)];
    scroll2(
      animate2(
        media,
        { transform: [`scale(${scale}) translateY(${translate}%)`, `scale(${scale}) translateY(0)`] },
        { easing: "linear" },
      ),
      {
        target: this,
        offset: ["start end", "end start"],
      },
    );
  }
};
if (!window.customElements.get("image-banner")) {
  window.customElements.define("image-banner", ImageBanner);
}

// js/sections/image-link-blocks.js
import { ScrollArea } from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";

var ImageLinkBlocks = class extends HTMLElement {
  _usesSwiperSlideA11y() {
    if (this.hasAttribute("data-a11y-slides")) {
      return true;
    }
    return (
      this.children.length > 0 &&
      Array.from(this.children).every((child) => child.classList?.contains("swiper-slide"))
    );
  }
  _getDirectChildFromNode(node) {
    let el = node;
    while (el && el !== this) {
      if (el.parentElement === this) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }
  _childUsesInnerLinkFocus(item) {
    if (!this.hasAttribute("data-a11y-keyboard-links")) {
      return false;
    }
    return Boolean(item.querySelector("a[href]"));
  }
  _getDirectChildA11yLabel(item) {
    const explicit =
      item.getAttribute("aria-label")?.trim() || item.getAttribute("data-a11y-label")?.trim();
    if (explicit) {
      return explicit;
    }
    const bottom = item.querySelector(".max-swiper-card-bottom-text")?.textContent?.trim();
    if (bottom) {
      return bottom;
    }
    const title = item.querySelector(
      ".new-image-link-blocks__title, .image-link-blocks__title, .card-content",
    )?.textContent?.trim();
    if (title) {
      return title.replace(/\s+/g, " ");
    }
    const img = item.querySelector('img[alt]:not([alt=""])');
    return img?.getAttribute("alt")?.trim() || "";
  }
  /** 宿主 image-link-blocks 不可 Tab；仅第一层子节点（或子节点内链）可聚焦 */
  _bindDirectChildFocusA11y() {
    this.removeAttribute("tabindex");
    this.dataset.a11yRegionBound = "false";
    if (!this.hasAttribute("aria-roledescription")) {
      this.setAttribute("aria-roledescription", "carousel");
    }
    const regionLabel = this.getAttribute("data-a11y-label");
    if (regionLabel && !this.hasAttribute("aria-label")) {
      this.setAttribute("aria-label", regionLabel);
    }

    const syncItems = () => {
      this.items.forEach((item) => {
        if (item.nodeType !== Node.ELEMENT_NODE) {
          return;
        }
        if (this._childUsesInnerLinkFocus(item)) {
          item.tabIndex = -1;
          item.removeAttribute("role");
          item.removeAttribute("aria-roledescription");
          return;
        }
        item.tabIndex = 0;
        if (!item.hasAttribute("role")) {
          item.setAttribute("role", "group");
        }
        item.setAttribute("aria-roledescription", "slide");
        const label = this._getDirectChildA11yLabel(item);
        if (label) {
          item.setAttribute("aria-label", label);
        }
      });
      if (this.hasAttribute("data-a11y-keyboard-links")) {
        window.A11yLinkKeyboard?.scan?.(this);
      }
    };
    syncItems();

    if (this._itemFocusA11yBound) {
      return;
    }
    this._itemFocusA11yBound = true;

    this._itemFocusIn = (event) => {
      const item = this._getDirectChildFromNode(event.target);
      if (!item) {
        return;
      }
      const index = this.items.indexOf(item);
      if (index >= 0) {
        this._scrollToIndex(index);
      }
    };
    this.addEventListener("focusin", this._itemFocusIn);

    this._itemFocusKeydown = (event) => {
      const item = this._getDirectChildFromNode(event.target);
      if (!item) {
        return;
      }
      const index = this.items.indexOf(item);
      if (index === -1) {
        return;
      }

      let targetIndex = null;
      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          targetIndex = index + 1;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          targetIndex = index - 1;
          break;
        case "Home":
          targetIndex = 0;
          break;
        case "End":
          targetIndex = this.items.length - 1;
          break;
        default:
          return;
      }

      if (targetIndex < 0 || targetIndex >= this.items.length || targetIndex === index) {
        return;
      }

      event.preventDefault();
      const targetItem = this.items[targetIndex];
      this._scrollToIndex(targetIndex);
      if (this._childUsesInnerLinkFocus(targetItem)) {
        targetItem.querySelector("a[href]")?.focus?.();
      } else {
        targetItem.focus();
      }
    };
    this.addEventListener("keydown", this._itemFocusKeydown);
  }
  _bindSwiperSlideA11y() {
    this.removeAttribute("tabindex");
    this.dataset.a11yRegionBound = "false";
    if (!this.hasAttribute("aria-roledescription")) {
      this.setAttribute("aria-roledescription", "carousel");
    }
    const regionLabel = this.getAttribute("data-a11y-label");
    if (regionLabel && !this.hasAttribute("aria-label")) {
      this.setAttribute("aria-label", regionLabel);
    }

    const syncSlides = () => {
      this.items.forEach((slide) => {
        if (!slide.classList.contains("swiper-slide")) {
          return;
        }
        slide.tabIndex = 0;
        if (!slide.hasAttribute("role")) {
          slide.setAttribute("role", "group");
        }
        slide.setAttribute("aria-roledescription", "slide");
        const heading = slide.querySelector(".slide-h2");
        const label = heading?.textContent?.trim();
        if (label) {
          slide.setAttribute("aria-label", label);
        }
      });
    };
    syncSlides();

    if (this._swiperSlideA11yBound) {
      return;
    }
    this._swiperSlideA11yBound = true;

    this._swiperSlideFocusIn = (event) => {
      const slide = event.target.closest?.(".swiper-slide");
      if (!slide || !this.contains(slide)) {
        return;
      }
      const index = this.items.indexOf(slide);
      if (index >= 0) {
        this._scrollToIndex(index);
      }
    };
    this.addEventListener("focusin", this._swiperSlideFocusIn);

    this._swiperSlideKeydown = (event) => {
      const slide = event.target.closest?.(".swiper-slide");
      if (!slide || !this.contains(slide)) {
        return;
      }
      const index = this.items.indexOf(slide);
      if (index === -1) {
        return;
      }

      let targetIndex = null;
      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          targetIndex = index + 1;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          targetIndex = index - 1;
          break;
        case "Home":
          targetIndex = 0;
          break;
        case "End":
          targetIndex = this.items.length - 1;
          break;
        default:
          return;
      }

      if (targetIndex < 0 || targetIndex >= this.items.length || targetIndex === index) {
        return;
      }

      event.preventDefault();
      const targetSlide = this.items[targetIndex];
      this._scrollToIndex(targetIndex);
      targetSlide.focus();
    };
    this.addEventListener("keydown", this._swiperSlideKeydown);
  }
  _syncMaxSwiperItems() {
    this.items = Array.from(this.children).filter((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
      }
      if (node.classList.contains("max-swiper-edge-spacer")) {
        return false;
      }
      return true;
    });
  }

  _isMaxSwiperCarousel() {
    return this.classList.contains("max-swiper-cards");
  }

  connectedCallback() {
    if (this._isMaxSwiperCarousel()) {
      this._syncMaxSwiperItems();
    } else if (
      this.classList.contains("new-image-link-blocks") ||
      this.tagName === "NEW-CARD-COVER-FLOW"
    ) {
      this.items = Array.from(this.children).filter((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return false;
        }
        return !node.classList.contains("new-carousel-edge-spacer");
      });
    } else {
      this.items = Array.from(this.children).filter((node) => node.nodeType === Node.ELEMENT_NODE);
    }
    new ScrollArea(this);
    if (this._usesSwiperSlideA11y()) {
      this._bindSwiperSlideA11y();
    } else {
      this._bindDirectChildFocusA11y();
    }

    this.addEventListener("control:prev", this._prev);
    this.addEventListener("control:next", this._next);

    this._scrollTimeout = null;
    this._lastIndex = 0;
    this.addEventListener("scroll", this._handleScrollDebounced.bind(this), { passive: true });

    this.addEventListener("control:select", (event) => {
      this._scrollToIndex(event.detail.index);
    });
  }

  disconnectedCallback() {
    this._a11yResizeObserver?.disconnect();
  }

  _handleScrollDebounced() {
    if (this._scrollTimeout) {
      clearTimeout(this._scrollTimeout);
    }

    this._scrollTimeout = setTimeout(() => {
      this._handleScroll();
    }, 100);
  }

  _handleScroll() {
    const currentIndex = this._calculateCurrentIndex();

    if (this._lastIndex !== currentIndex) {
      this._lastIndex = currentIndex;

      this.dispatchEvent(
        new CustomEvent("scroll:change", {
          detail: { index: currentIndex },
          bubbles: true,
        }),
      );
    }
  }

  _getScrollCenter() {
    return this.scrollLeft + this.clientWidth / 2;
  }

  _calculateCurrentIndex() {
    if (!this.items.length) return 0;

    const scrollCenter = this._getScrollCenter();
    let closestIndex = 0;
    let closestDistance = Infinity;

    this.items.forEach((item, index) => {
      const itemCenter = item.offsetLeft + item.clientWidth / 2;
      const distance = Math.abs(itemCenter - scrollCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  _computeScrollLeftForIndex(index) {
    if (!this.items[index]) return 0;

    const targetItem = this.items[index];
    const containerWidth = this.clientWidth;
    const itemWidth = targetItem.clientWidth;
    const maxScrollLeft = Math.max(0, this.scrollWidth - containerWidth);

    let scrollLeft;
    if (index === this.items.length - 1 && !this._isMaxSwiperCarousel()) {
      scrollLeft = maxScrollLeft;
    } else {
      scrollLeft = targetItem.offsetLeft - (containerWidth - itemWidth) / 2;
    }

    return Math.max(0, Math.min(scrollLeft, maxScrollLeft));
  }

  _scrollToIndex(index) {
    if (!this.items[index]) return;

    const maxScrollLeft = Math.max(0, this.scrollWidth - this.clientWidth);
    const scrollLeft = this._computeScrollLeftForIndex(index);

    this.scrollTo({
      left: scrollLeft,
      behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto",
    });
  }

  _prev() {
    const index = this._calculateCurrentIndex();
    if (this.classList.contains("new-image-link-blocks") && this.tagName !== "NEW-CARD-COVER-FLOW") {
      return;
    }
    if (this.classList.contains("max-swiper-cards")) {
      return;
    }
    if (index <= 0) {
      this.scrollTo({ left: 0, behavior: "smooth" });
      return;
    }
    this._scrollToIndex(index - 1);
  }

  _next() {
    const index = this._calculateCurrentIndex();
    if (this.classList.contains("new-image-link-blocks") && this.tagName !== "NEW-CARD-COVER-FLOW") {
      return;
    }
    if (this.classList.contains("max-swiper-cards")) {
      return;
    }
    if (index >= this.items.length - 1) {
      this.scrollTo({
        left: this.scrollWidth - this.clientWidth,
        behavior: "smooth",
      });
      return;
    }
    this._scrollToIndex(index + 1);
  }
};
if (!window.customElements.get("image-link-blocks")) {
  window.customElements.define("image-link-blocks", ImageLinkBlocks);
}

// js/sections/new-card-cover-flow.js — testimonial Cover Flow（extends ImageLinkBlocks）
var NewCardCoverFlow = class extends ImageLinkBlocks {
  connectedCallback() {
    if (this.dataset.coverFlowReady === "true") return;
    if (this._cfIsPadOrPc()) {
      this._cfMountLoopClones();
    } else {
      this.querySelectorAll(".new-carousel-loop-clone").forEach((el) => el.remove());
    }
    super.connectedCallback();
    this._cfRefreshItems();
    this.dataset.coverFlowReady = "true";
    this._cfSnapGen = 0;
    this._cfLastIntended = null;
    this._cfNavAnimating = false;
    this._cfNavTarget = null;
    this._cfSmoothStartedAt = 0;
    this._cfNavFinishTimer = null;
    this._cfSnapRaf = null;
    this._cfSyncRaf = null;
    this._cfOnScrollEnd = this._cfHandleScrollEnd.bind(this);
    this._cfOnScroll = this._cfHandleScroll.bind(this);
    this._cfOnResize = this._cfHandleResize.bind(this);
    this._cfSyncLoop = this._cfSyncLoopControls.bind(this);
    this._cfOnPointerDown = this._cfHandlePointerDown.bind(this);
    this._cfUserScrolling = false;
    this._cfUserScrollEndTimer = null;
    this._cfResizeTimer = null;

    this.addEventListener("scrollend", this._cfOnScrollEnd, { passive: true });
    this.addEventListener("scroll", this._cfOnScroll, { passive: true });
    this.addEventListener("pointerdown", this._cfOnPointerDown, { passive: true });
    this.addEventListener("touchstart", this._cfOnPointerDown, { passive: true });
    this.addEventListener("scroll:edge-nearing", this._cfSyncLoop);
    this.addEventListener("scroll:edge-leaving", this._cfSyncLoop);
    window.addEventListener("resize", this._cfOnResize);

    const initial = this._cfInitialIndex();
    this._cfSyncEdgeSpacers();
    this._cfGoToIndex(initial, "auto", "init");
    this._cfSyncLoopControls();
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.removeEventListener("scrollend", this._cfOnScrollEnd);
    this.removeEventListener("scroll", this._cfOnScroll);
    this.removeEventListener("pointerdown", this._cfOnPointerDown);
    this.removeEventListener("touchstart", this._cfOnPointerDown);
    this.removeEventListener("scroll:edge-nearing", this._cfSyncLoop);
    this.removeEventListener("scroll:edge-leaving", this._cfSyncLoop);
    window.removeEventListener("resize", this._cfOnResize);
    if (this._cfNavFinishTimer) clearTimeout(this._cfNavFinishTimer);
    if (this._cfUserScrollEndTimer) clearTimeout(this._cfUserScrollEndTimer);
    if (this._cfResizeTimer) clearTimeout(this._cfResizeTimer);
  }

  _cfHandlePointerDown() {
    this._cfUserScrolling = true;
    this._cfSetNavAnimating(false);
    this._cfLastIntended = null;
    this._cfNavTarget = null;
    if (this._cfSnapRaf != null) {
      cancelAnimationFrame(this._cfSnapRaf);
      this._cfSnapRaf = null;
    }
    if (this._cfNavFinishTimer) {
      clearTimeout(this._cfNavFinishTimer);
      this._cfNavFinishTimer = null;
    }
    if (this._cfUserScrollEndTimer) {
      clearTimeout(this._cfUserScrollEndTimer);
      this._cfUserScrollEndTimer = null;
    }
    ++this._cfSnapGen;
  }

  _cfScheduleUserScrollSettle(source) {
    if (this._cfUserScrollEndTimer) clearTimeout(this._cfUserScrollEndTimer);
    this._cfUserScrollEndTimer = setTimeout(() => {
      this._cfUserScrollEndTimer = null;
      this._cfUserScrolling = false;
      this._cfFinishUserScroll(source);
    }, this._cfIsMobile() ? 140 : 80);
  }

  _cfFinishUserScroll(source) {
    const index = this._calculateCurrentIndex();
    const dedupeKey = `user:${index}:${Math.round(this.scrollLeft / 8)}`;
    if (this._cfScrollEndDedupe === dedupeKey) return index;
    this._cfScrollEndDedupe = dedupeKey;
    this._cfLastIntended = index;
    this._cfSyncEdgeSpacers();
    this._cfApplyClasses(index);
    if (!this._cfIsMobile()) {
      const slack = 56;
      if (!this._cfIsScrollClose(index, slack)) {
        const left = this._cfScrollLeftForIndex(index);
        this.scrollTo({ left: left, behavior: "auto" });
        this._cfApplyClasses(index);
      }
    }
    this._cfSyncLoopControls();
    return index;
  }

  _prev() {
    if (this.items.length <= 1 || this._cfNavAnimating) return;
    const current = this._cfCurrentNavIndex();
    const last = this.items.length - 1;
    if (current === 0) {
      if (this._cfIsMobile()) return;
      this._cfGoToIndex(last, "smooth", "control:prev-loop");
      return;
    }
    this._cfGoToIndex(current - 1, "smooth", "control:prev");
  }

  _next() {
    if (this.items.length <= 1 || this._cfNavAnimating) return;
    const current = this._cfCurrentNavIndex();
    const last = this.items.length - 1;
    if (current === last) {
      if (this._cfIsMobile()) return;
      this._cfGoToIndex(0, "smooth", "control:next-loop");
      return;
    }
    this._cfGoToIndex(current + 1, "smooth", "control:next");
  }

  _cfInitialIndex() {
    const n = this.items.length;
    if (n <= 1) return 0;
    return 0;
  }

  _cfGetRealItemElements() {
    return Array.from(this.children).filter((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return false;
      if (node.classList.contains("new-carousel-edge-spacer")) return false;
      if (node.classList.contains("new-carousel-loop-clone")) return false;
      return node.classList.contains("new-image-link-blocks__item");
    });
  }

  _cfRefreshItems() {
    this.items = this._cfGetRealItemElements();
  }

  _cfMountLoopClones() {
    if (this.querySelector(".new-carousel-loop-clone")) return;
    const real = this._cfGetRealItemElements();
    if (real.length < 2) return;

    const first = real[0];
    const last = real[real.length - 1];
    const spacers = this.querySelectorAll(".new-carousel-edge-spacer");

    const cloneTail = last.cloneNode(true);
    cloneTail.classList.add("new-carousel-loop-clone", "new-carousel-loop-clone--tail");
    cloneTail.removeAttribute("id");
    cloneTail.setAttribute("aria-hidden", "true");
    cloneTail.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));

    const cloneHead = first.cloneNode(true);
    cloneHead.classList.add("new-carousel-loop-clone", "new-carousel-loop-clone--head");
    cloneHead.removeAttribute("id");
    cloneHead.setAttribute("aria-hidden", "true");
    cloneHead.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));

    if (spacers[0]) {
      spacers[0].after(cloneTail);
    } else {
      this.prepend(cloneTail);
    }
    if (spacers.length > 1) {
      spacers[spacers.length - 1].before(cloneHead);
    } else {
      this.appendChild(cloneHead);
    }
  }

  _cfClearLoopCloneRoles() {
    this.querySelectorAll(".new-carousel-loop-clone").forEach((el) => {
      el.classList.remove(
        "active",
        "prev",
        "next",
        "peek-prev",
        "peek-next",
        "peek-far-prev",
        "peek-far-next",
      );
    });
  }

  _cfApplyLoopCloneRoles(activeIndex) {
    this._cfClearLoopCloneRoles();
    if (!this._cfIsPadOrPc()) return;
    const n = this.items.length;
    const tail = this.querySelector(".new-carousel-loop-clone--tail");
    const head = this.querySelector(".new-carousel-loop-clone--head");
    if (!tail || !head) return;

    if (activeIndex === 0) {
      tail.classList.add("prev");
    } else if (activeIndex === 1) {
      tail.classList.add("peek-far-prev");
    }
    if (activeIndex === n - 1) {
      head.classList.add("next");
    } else if (activeIndex === n - 2) {
      head.classList.add("peek-far-next");
    }
  }

  _cfWrapIndex(index) {
    const n = this.items.length;
    if (n <= 0) return 0;
    return ((index % n) + n) % n;
  }

  _cfIsDesktopWide() {
    return window.matchMedia("(min-width: 769px)").matches;
  }

  _cfIsPadOrPc() {
    return window.matchMedia("(min-width: 701px)").matches;
  }

  _cfIsMobile() {
    return window.matchMedia("(max-width: 700px)").matches;
  }

  _cfTrackGap() {
    const gap = getComputedStyle(this).columnGap || getComputedStyle(this).gap;
    const n = parseFloat(gap);
    return Number.isFinite(n) ? n : 0;
  }

  _cfSideCardWidth() {
    const probe = this.items[0];
    if (!probe) return 0;
    const saved = {
      a: probe.classList.contains("active"),
      p: probe.classList.contains("prev"),
      n: probe.classList.contains("next"),
    };
    probe.classList.remove("active", "prev", "next", "peek-prev", "peek-next", "peek-far-prev", "peek-far-next");
    const w = probe.clientWidth;
    probe.classList.toggle("active", saved.a);
    probe.classList.toggle("prev", saved.p);
    probe.classList.toggle("next", saved.n);
    return w;
  }

  _cfActiveCardWidth() {
    const token = getComputedStyle(this).getPropertyValue("--new-image-link-blocks-item-width").trim();
    if (token) {
      const probe = document.createElement("div");
      probe.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;width:${token};`;
      this.appendChild(probe);
      const w = probe.offsetWidth;
      probe.remove();
      if (w > 0) return w;
    }
    return this.items[0]?.clientWidth ?? 0;
  }

  _cfSyncEdgeSpacers() {
    const activeW = this._cfActiveCardWidth();
    const sideW = this._cfSideCardWidth();
    const gap = this._cfTrackGap();
    const fullInset = Math.max(0, (this.clientWidth - activeW) / 2);
    let inset = fullInset;

    if (this._cfIsPadOrPc() && sideW > 0) {
      const peekPad = sideW + gap;
      const hasLoop = !!this.querySelector(".new-carousel-loop-clone");
      const peekLanes = hasLoop ? 2 : 1;
      inset = Math.max(0, fullInset - peekPad * peekLanes);
    }

    this.querySelectorAll(".new-carousel-edge-spacer").forEach((el) => {
      el.style.width = `${inset}px`;
      el.style.minWidth = `${inset}px`;
    });
    this.style.setProperty("--new-carousel-edge-spacer", `${inset}px`);
    this.dataset.carouselWide = this._cfIsPadOrPc() ? "true" : "false";
  }

  _computeScrollLeftForIndex(index) {
    if (!this.items[index]) return 0;

    const targetItem = this.items[index];
    const containerWidth = this.clientWidth;
    const itemWidth = targetItem.clientWidth;
    const maxScrollLeft = Math.max(0, this.scrollWidth - containerWidth);
    const scrollLeft = targetItem.offsetLeft + itemWidth / 2 - containerWidth / 2;

    return Math.max(0, Math.min(scrollLeft, maxScrollLeft));
  }

  _cfApplyClasses(activeIndex) {
    const n = this.items.length;
    const padOrPc = this._cfIsPadOrPc();
    this.items.forEach((item) => {
      item.classList.remove("active", "prev", "next", "peek-prev", "peek-next", "peek-far-prev", "peek-far-next");
    });
    if (!this.items[activeIndex]) return;
    this.items[activeIndex].classList.add("active");
    if (activeIndex > 0) this.items[activeIndex - 1]?.classList.add("prev");
    if (activeIndex + 1 < n) this.items[activeIndex + 1]?.classList.add("next");
    if (padOrPc) {
      if (activeIndex > 1) this.items[activeIndex - 2]?.classList.add("peek-prev");
      if (activeIndex + 2 < n) this.items[activeIndex + 2]?.classList.add("peek-next");
      if (activeIndex > 2) this.items[activeIndex - 3]?.classList.add("peek-far-prev");
      if (activeIndex + 3 < n) this.items[activeIndex + 3]?.classList.add("peek-far-next");
    }
    this._cfApplyLoopCloneRoles(activeIndex);
  }

  _cfScrollLeftForIndex(index) {
    return this._computeScrollLeftForIndex(index);
  }

  _cfIsScrollClose(index, slack = 48) {
    if (!this.items[index]) return false;
    const target = this._cfScrollLeftForIndex(index);
    return Math.abs(this.scrollLeft - target) <= slack;
  }

  _cfCurrentNavIndex() {
    if (this._cfNavAnimating && this._cfNavTarget != null) return this._cfNavTarget;
    if (this._cfLastIntended != null) return this._cfLastIntended;
    return this._calculateCurrentIndex();
  }

  _cfResolveActiveIndex() {
    const closest = this._calculateCurrentIndex();
    const intended = this._cfNavAnimating ? this._cfNavTarget : this._cfLastIntended;
    if (intended == null || intended < 0) return closest;
    if (this._cfIsScrollClose(intended)) return intended;
    return closest;
  }

  _cfSetNavAnimating(active, targetIndex = null) {
    this._cfNavAnimating = active;
    this._cfNavTarget = active ? targetIndex : null;
    this.classList.toggle("is-carousel-nav-animating", active);
    if (!active && this._cfNavFinishTimer) {
      clearTimeout(this._cfNavFinishTimer);
      this._cfNavFinishTimer = null;
    }
  }

  _cfFinishNavigation(intended, source = "scrollend") {
    if (source === "scrollend") {
      const dedupeKey = `${intended}:${Math.round(this.scrollLeft / 4)}`;
      if (this._cfScrollEndDedupe === dedupeKey) return intended;
      this._cfScrollEndDedupe = dedupeKey;
    }
    this._cfSetNavAnimating(false);
    if (intended == null) {
      this._cfApplyClasses(this._cfResolveActiveIndex());
      return this._calculateCurrentIndex();
    }
    this._cfSyncEdgeSpacers();
    this._cfApplyClasses(intended);
    if (!this._cfIsScrollClose(intended)) {
      const left = this._cfScrollLeftForIndex(intended);
      this.scrollTo({ left, behavior: "auto" });
      this._cfApplyClasses(intended);
    }
    this._cfLastIntended = intended;
    return intended;
  }

  _cfScheduleNavFinish(intended) {
    if (this._cfNavFinishTimer) clearTimeout(this._cfNavFinishTimer);
    const wait = Math.max(80, 850 - (Date.now() - this._cfSmoothStartedAt));
    this._cfNavFinishTimer = setTimeout(() => {
      this._cfNavFinishTimer = null;
      if (!this._cfNavAnimating) return;
      this._cfFinishNavigation(intended, "nav-timeout");
    }, wait);
  }

  _cfRunScrollStep(index, behavior, source, gen) {
    if (gen !== this._cfSnapGen) return;
    this._cfSyncEdgeSpacers();
    this._cfApplyClasses(index);
    const left = this._cfScrollLeftForIndex(index);
    this.scrollTo({ left: left, behavior: behavior });
    this._cfSyncLoopControls();
    if (behavior !== "smooth") {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (gen !== this._cfSnapGen) return;
          this._cfFinishNavigation(index, "goToIndex-auto");
        });
      });
    }
  }

  _cfGoToIndex(index, behavior = "auto", source = "unknown") {
    if (!this.items[index]) return;
    this._cfScrollEndDedupe = null;
    this._cfLastIntended = index;
    const gen = ++this._cfSnapGen;
    this._cfApplyClasses(index);
    this._cfSyncEdgeSpacers();
    if (behavior === "smooth") {
      this._cfSetNavAnimating(true, index);
      this._cfSmoothStartedAt = Date.now();
    } else {
      this._cfSetNavAnimating(false);
    }
    if (this._cfSnapRaf != null) {
      cancelAnimationFrame(this._cfSnapRaf);
    }
    this._cfSnapRaf = requestAnimationFrame(() => {
      this._cfSnapRaf = requestAnimationFrame(() => {
        this._cfSnapRaf = null;
        this._cfRunScrollStep(index, behavior, source, gen);
      });
    });
  }

  _cfSyncLoopControls() {
    const n = this.items.length;
    const root = this.closest(".floating-controls-container") || this.parentElement;
    if (!root) return;
    const idx = this._cfResolveActiveIndex();
    root.querySelectorAll(`[aria-controls="${this.id}"]`).forEach((btn) => {
      if (n <= 1) {
        btn.disabled = true;
        return;
      }
      if (!this._cfIsMobile()) {
        btn.disabled = false;
        return;
      }
      const role = btn.getAttribute("is");
      if (role === "prev-button") {
        btn.disabled = idx <= 0;
      } else if (role === "next-button") {
        btn.disabled = idx >= n - 1;
      }
    });
  }

  _cfHandleScroll() {
    if (this._cfNavAnimating) return;
    if (this._cfIsMobile() && this._cfUserScrolling) return;
    if (this._cfSyncRaf != null) return;
    this._cfSyncRaf = requestAnimationFrame(() => {
      this._cfSyncRaf = null;
      this._cfApplyClasses(this._cfResolveActiveIndex());
    });
  }

  _cfHandleScrollEnd() {
    if (!this._cfNavAnimating) {
      this._cfScheduleUserScrollSettle("scrollend");
      return;
    }
    const intended = this._cfLastIntended ?? this._cfNavTarget;
    if (intended != null && !this._cfIsScrollClose(intended, 48)) {
      if (Date.now() - this._cfSmoothStartedAt < 850) {
        this._cfScheduleNavFinish(intended);
        return;
      }
    }
    this._cfFinishNavigation(intended, "scrollend");
  }

  _cfHandleResize() {
    if (this._cfResizeTimer) clearTimeout(this._cfResizeTimer);
    this._cfResizeTimer = setTimeout(() => {
      this._cfResizeTimer = null;
      const idx = this._cfResolveActiveIndex();
      if (this._cfIsPadOrPc()) {
        if (!this.querySelector(".new-carousel-loop-clone")) {
          this._cfMountLoopClones();
          this._cfRefreshItems();
        }
      } else {
        this.querySelectorAll(".new-carousel-loop-clone").forEach((el) => el.remove());
        this._cfRefreshItems();
      }
      this._cfSyncEdgeSpacers();
      this._cfGoToIndex(idx, "auto", "resize");
    }, 180);
  }
};
if (!window.customElements.get("new-card-cover-flow")) {
  window.customElements.define("new-card-cover-flow", NewCardCoverFlow);
}

// js/sections/blur-image.js
// 模糊占位 → 高清主图：<blur-image> 与 [data-blur-image] 兼容；BlurImage.bind(root) 用于弹窗等局部初始化
var BlurImage = class extends HTMLElement {
  connectedCallback() {
    this._bind();
  }

  static bind(root = document) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    scope.querySelectorAll("blur-image, [data-blur-image]").forEach((el) => {
      if (el._bindBlurImage) {
        el._bindBlurImage();
      } else {
        BlurImage.prototype._bind.call(el);
      }
    });
  }

  _bind() {
    if (this.dataset.blurBound === "true") {
      this._syncLoadedState();
      return;
    }
    this.dataset.blurBound = "true";

    const mainImg = this.querySelector(".blur-image__main, .blur-img__main");
    if (!mainImg) return;

    const markLoaded = () => {
      this.classList.add("is-loaded");
      if (mainImg.complete && mainImg.naturalWidth > 0) {
        this.classList.add("is-cached");
      }
    };

    if (mainImg.complete && mainImg.naturalWidth > 0) {
      markLoaded();
    } else {
      mainImg.addEventListener("load", markLoaded, { once: true });
      mainImg.addEventListener("error", () => this.classList.add("is-error"), { once: true });
    }
  }

  _syncLoadedState() {
    const mainImg = this.querySelector(".blur-image__main, .blur-img__main");
    if (!mainImg?.complete || mainImg.naturalWidth <= 0) return;
    this.classList.add("is-loaded", "is-cached");
  }
};

BlurImage.prototype._bindBlurImage = BlurImage.prototype._bind;

if (!window.customElements.get("blur-image")) {
  window.customElements.define("blur-image", BlurImage);
}

window.BlurImage = BlurImage;

document.addEventListener("DOMContentLoaded", () => BlurImage.bind());
document.addEventListener("shopify:section:load", (event) => {
  if (event.target) BlurImage.bind(event.target);
});

import { ScrollArea as ScrollArea2 } from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var NewImageLinkBlocks = class extends HTMLElement {
  connectedCallback() {
    this.items = [...this.children];
    this._scrollArea = new ScrollArea2(this);
    bindScrollRegionA11y(this);
    this._scrollTimeout = null;
    this._lastIndex = 0;
    this._reducedMotion = window.matchMedia("(prefers-reduced-motion: no-preference)");

    this.addEventListener("control:prev", () => this._prev());
    this.addEventListener("control:next", () => this._next());
    this.addEventListener("scroll", this._handleScrollDebounced.bind(this), { passive: true });
    this.addEventListener("control:select", ({ detail: { index } }) => this._scrollToIndex(index));

    this._activeObserver = new MutationObserver((mutations) => {
      for (const { type, attributeName, target } of mutations) {
        if (type === "attributes" && attributeName === "class" && target.classList.contains("active")) {
          requestAnimationFrame(() => this._scrollItemIntoView(target));
          break;
        }
      }
    });
    this.items.forEach((item) => this._activeObserver.observe(item, { attributes: true, attributeFilter: ["class"] }));

    this._initializeScrollPosition();
  }

  disconnectedCallback() {
    this._activeObserver?.disconnect();
    this._a11yResizeObserver?.disconnect();
    clearTimeout(this._scrollTimeout);
  }

  _initializeScrollPosition() {
    requestAnimationFrame(() => {
      this._scrollActiveIntoView();
      this._checkEdgeState();
      setTimeout(() => {
        this._scrollActiveIntoView();
        this._checkEdgeState();
      }, 100);
    });
  }

  _checkEdgeState() {
    const { scrollLeft, scrollWidth, clientWidth } = this;
    const maxScrollLeft = scrollWidth - clientWidth;
    const threshold = 5;
    const dispatch = (position, isNearing) =>
      this.dispatchEvent(
        new CustomEvent(isNearing ? "scroll:edge-nearing" : "scroll:edge-leaving", {
          bubbles: true,
          detail: { position },
        }),
      );

    dispatch("start", scrollLeft <= threshold);
    dispatch("end", scrollLeft >= maxScrollLeft - threshold);
  }

  get viewBounds() {
    return {
      left: this.scrollLeft,
      right: this.scrollLeft + this.clientWidth,
    };
  }

  _getItemBounds(item) {
    return {
      left: item.offsetLeft,
      right: item.offsetLeft + item.clientWidth,
    };
  }

  _scrollActiveIntoView() {
    this._scrollItemIntoView(this.items.find((el) => el.classList.contains("active")));
  }

  _scrollItemIntoView(item) {
    if (!item || this.scrollWidth <= this.clientWidth) return;

    const itemRect = item.getBoundingClientRect();
    const hostRect = this.getBoundingClientRect();
    const itemRelativeLeft = itemRect.left - hostRect.left;
    const itemRelativeRight = itemRelativeLeft + itemRect.width;
    const padding = 20;

    let targetScrollLeft = null;

    if (itemRelativeLeft < padding) {
      targetScrollLeft = this.scrollLeft + itemRelativeLeft - padding;
    } else if (itemRelativeRight > this.clientWidth - padding) {
      targetScrollLeft = this.scrollLeft + (itemRelativeRight - this.clientWidth + padding);
    }

    if (targetScrollLeft === null) return;

    this._performScroll(targetScrollLeft);
  }

  _performScroll(targetScrollLeft, callback) {
    const maxScrollLeft = this.scrollWidth - this.clientWidth;

    this.scrollTo({
      left: Math.max(0, Math.min(targetScrollLeft, maxScrollLeft)),
      behavior: this._reducedMotion.matches ? "smooth" : "auto",
    });

    setTimeout(() => {
      this._checkEdgeState();
      callback?.();
    }, 350);
  }

  _handleScrollDebounced() {
    clearTimeout(this._scrollTimeout);
    this._scrollTimeout = setTimeout(() => this._handleScroll(), 100);
  }

  _handleScroll() {
    const currentIndex = this._calculateCurrentIndex();

    if (this._lastIndex !== currentIndex) {
      this._lastIndex = currentIndex;
      this.dispatchEvent(
        new CustomEvent("scroll:change", {
          detail: { index: currentIndex },
          bubbles: true,
        }),
      );
    }

    this._checkEdgeState();
  }

  _calculateCurrentIndex() {
    if (!this.items.length) return 0;

    const view = this.viewBounds;
    const index = this.items.findIndex((item) => {
      const { left, right } = this._getItemBounds(item);
      return left >= view.left && right <= view.right;
    });
    return index !== -1 ? index : 0;
  }

  _getNextIndex() {
    const viewRight = this.scrollLeft + this.clientWidth;
    const nextIndex = this.items.findIndex((item) => item.offsetLeft + item.clientWidth > viewRight + 1);
    return nextIndex !== -1 ? nextIndex : this.items.length - 1;
  }

  _getPrevIndex() {
    const viewLeft = this.scrollLeft;
    const prevIndex = [...this.items].reverse().findIndex((item) => item.offsetLeft < viewLeft - 1);
    return prevIndex !== -1 ? this.items.length - 1 - prevIndex : 0;
  }

  _getFirstVisibleIndex() {
    const view = this.viewBounds;
    const index = this.items.findIndex((item) => {
      const { left, right } = this._getItemBounds(item);
      return right > view.left + 1 && left < view.right - 1;
    });
    return index !== -1 ? index : 0;
  }

  _scrollToIndex(index) {
    this._scrollItemIntoView(this.items[index]);
  }

  _prev() {
    if (!this.items.length) return;

    const firstVisibleIndex = this._getFirstVisibleIndex();

    if (firstVisibleIndex <= 1) {
      this._performScroll(0);
      return;
    }

    this._scrollToIndex(firstVisibleIndex - 1);
  }

  _next() {
    if (!this.items.length) return;
    this._scrollToIndex(this._getNextIndex());
  }
};

if (!window.customElements.get("new-image-link-blocks")) {
  window.customElements.define("new-image-link-blocks", NewImageLinkBlocks);
}

var DoubleSided = class extends HTMLElement {
  connectedCallback() {
    this.images = this.querySelectorAll(".image-wrapper");
    this.icons = this.querySelectorAll(".hover-icon");
    this._pcHoverToggle = this.hasAttribute("data-pc-hover-toggle");
    this._mq = null;
    this._onIconClickBound = [];

    if (this._pcHoverToggle) {
      this._mq = window.matchMedia("(min-width: 1280px)");
      this._onMqChange = () => {
        if (this._mq.matches) {
          this._resetDefaultFace();
        }
      };
      this._mq.addEventListener("change", this._onMqChange);
      if (this._mq.matches) {
        this._resetDefaultFace();
      }

      // PC hover 事件：鼠标移入 image-container 触发，离开后恢复
      this._pcMouseenterBound = [];
      this._pcMouseleaveBound = [];

      const onContainerEnter = () => {
        if (this._mq && this._mq.matches) {
          this.classList.add("is-hovered");
        }
      };
      const onContainerLeave = () => {
        if (this._mq && this._mq.matches) {
          this.classList.remove("is-hovered");
        }
      };
      this._pcMouseenterBound.push({ icon: this, fn: onContainerEnter });
      this._pcMouseleaveBound.push({ icon: this, fn: onContainerLeave });
      this.addEventListener("mouseenter", onContainerEnter);
      this.addEventListener("mouseleave", onContainerLeave);
    }

    // 移动端只用非 close-icon 的图标做翻转，过滤掉 PC 专用的 close-icon
    const mobileIcons = Array.from(this.icons).filter((ic) => !ic.classList.contains("close-icon"));
    this.icons.forEach((icon, index) => {
      const fn = () => {
        if (this._pcHoverToggle && this._mq && this._mq.matches) {
          // PC 下由 hover 控制，点击无效
          return;
        }
        // 移动端/平板（仅 data-pc-hover-toggle 版本）：open-icon 展开，close-icon 收起
        if (this._pcHoverToggle && icon.classList.contains("close-icon")) {
          this._onImageClick(-1);
          return;
        }
        const mobileIndex = mobileIcons.indexOf(icon);
        if (mobileIndex !== -1) this._onImageClick(mobileIndex);
      };
      this._onIconClickBound.push(fn);
      icon.addEventListener("click", fn);
    });
  }

  disconnectedCallback() {
    if (this._mq) {
      this._mq.removeEventListener("change", this._onMqChange);
    }
    if (this._pcMouseenterBound) {
      this._pcMouseenterBound.forEach(({ icon, fn }) => {
        icon.removeEventListener("mouseenter", fn);
      });
    }
    if (this._pcMouseleaveBound) {
      this._pcMouseleaveBound.forEach(({ icon, fn }) => {
        icon.removeEventListener("mouseleave", fn);
      });
    }
    this.icons.forEach((icon, index) => {
      const fn = this._onIconClickBound[index];
      if (fn) {
        icon.removeEventListener("click", fn);
      }
    });
  }

  _resetDefaultFace() {
    this.images.forEach((image, i) => {
      image.classList.toggle("active", i === 0);
    });
    if (this._pcHoverToggle) {
      this.classList.remove("mobile-expanded");
    }
  }

  _onImageClick(index) {
    const isReset = index === -1;
    this.images.forEach((image, i) => {
      if (isReset) {
        image.classList.toggle("active", i === 0);
      } else if (i === index) {
        image.classList.remove("active");
      } else {
        image.classList.add("active");
      }
    });
    // 移动端图标切换（仅 data-pc-hover-toggle 版本）：展开时显示 close-icon，收起时显示 open-icon
    if (this._pcHoverToggle) {
      this.classList.toggle("mobile-expanded", !isReset && index !== -1);
    }
  }
};
if (!window.customElements.get("double-sided")) {
  window.customElements.define("double-sided", DoubleSided);
}
var ActiveSide = class extends HTMLElement {
  connectedCallback() {
    //console.log("ActiveSide");
    this.images = this.querySelectorAll(".swiper-slide");
    this.images.forEach((image, index) => {
      image.setAttribute("tabindex", "0");
      image.setAttribute("role", "button");
      const activate = this._onImageClick.bind(this, index);
      image.addEventListener("mouseover", activate);
      bindFocusActivate(image, activate);
      image.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          activate();
        }
      });
    });
    this.broImages = this.querySelectorAll(".swiper-slide-bro");
    let initialIndex = 0;
    this.images.forEach((image, i) => {
      if (image.classList.contains("active")) {
        initialIndex = i;
      }
    });
    this._syncTabSelection(initialIndex);
    if (this._isTabsImagTextSwiper2()) {
      this._setupTabsImagTextSwiper2FocusOrder();
    }
    if (this._isImageCardSwiper()) {
      this._syncImageCardSwiperLinkTabindex(initialIndex);
    }
  }
  _isImageCardSwiper() {
    return Boolean(this.closest(".image-card-swiper-section"));
  }
  _syncImageCardSwiperLinkTabindex(activeIndex) {
    this.images.forEach((slide, i) => {
      slide.querySelectorAll("a.slide-a[href]").forEach((link) => {
        link.setAttribute("tabindex", i === activeIndex ? "0" : "-1");
      });
    });
  }
  _isTabsImagTextSwiper2() {
    return Boolean(this.closest(".tabs-imag-text-swiper-2"));
  }
  _getActiveSlideIndex() {
    for (let i = 0; i < this.images.length; i++) {
      if (this.images[i].classList.contains("active")) {
        return i;
      }
    }
    return 0;
  }
  _getPanelFocusables(bro) {
    if (!bro) {
      return [];
    }
    const candidates = bro.querySelectorAll(
      'a[href], button:not([disabled]), .color-swatch[role="button"]',
    );
    return Array.from(candidates).filter((el) => el.getClientRects().length > 0);
  }
  _buildTabsImagTextSwiper2FocusOrder() {
    const order = [];
    const activeIndex = this._getActiveSlideIndex();
    for (let i = 0; i < this.images.length; i++) {
      order.push(this.images[i]);
      const panelFocusables = this._getPanelFocusables(this.broImages[i]);
      const isActivePanel = i === activeIndex;
      panelFocusables.forEach((el) => {
        el.setAttribute("tabindex", isActivePanel ? "0" : "-1");
      });
      if (isActivePanel) {
        order.push(...panelFocusables);
      }
    }
    return order;
  }
  _getTabsImagTextSwiper2Root() {
    return this.closest(".tabs-imag-text-swiper-2") ?? this;
  }
  _getSequentialFocusCandidates() {
    const selector =
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([aria-hidden="true"])';
    return Array.from(document.querySelectorAll(selector)).filter((el) => {
      if (!el.getClientRects().length) {
        return false;
      }
      return el.getAttribute("tabindex") !== "-1";
    });
  }
  _sortElementsByDocumentOrder(elements) {
    return elements.slice().sort((a, b) => {
      if (a === b) {
        return 0;
      }
      const position = a.compareDocumentPosition(b);
      if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
        return -1;
      }
      if (position & Node.DOCUMENT_POSITION_PRECEDING) {
        return 1;
      }
      return 0;
    });
  }
  _focusTabStopOutsideComponent(current, forward) {
    const root = this._getTabsImagTextSwiper2Root();
    const candidates = this._getSequentialFocusCandidates();
    const ordered = current && !candidates.includes(current) ? this._sortElementsByDocumentOrder([...candidates, current]) : candidates;
    const currentIndex = ordered.indexOf(current);
    if (currentIndex === -1) {
      return false;
    }
    if (forward) {
      for (let i = currentIndex + 1; i < ordered.length; i++) {
        if (!root.contains(ordered[i])) {
          ordered[i].focus();
          return true;
        }
      }
    } else {
      for (let i = currentIndex - 1; i >= 0; i--) {
        if (!root.contains(ordered[i])) {
          ordered[i].focus();
          return true;
        }
      }
    }
    return false;
  }
  _setupTabsImagTextSwiper2FocusOrder() {
    this._buildTabsImagTextSwiper2FocusOrder();
    if (this._tabsImagTextSwiper2TabBound) {
      return;
    }
    this._tabsImagTextSwiper2TabBound = (event) => {
      if (event.key !== "Tab") {
        return;
      }
      const order = this._buildTabsImagTextSwiper2FocusOrder();
      const active = document.activeElement;
      const index = order.indexOf(active);
      if (index === -1) {
        return;
      }
      const nextIndex = event.shiftKey ? index - 1 : index + 1;
      if (nextIndex < 0 || nextIndex >= order.length) {
        if (this._focusTabStopOutsideComponent(active, !event.shiftKey)) {
          event.preventDefault();
        }
        return;
      }
      event.preventDefault();
      order[nextIndex].focus();
    };
    this.addEventListener("keydown", this._tabsImagTextSwiper2TabBound);
  }
  _syncTabSelection(index) {
    if (!this._isTabsImagTextSwiper2()) {
      return;
    }
    this.images.forEach((image, i) => {
      image.setAttribute("aria-pressed", i === index ? "true" : "false");
    });
  }
  _onImageClick(index) {
    this.images.forEach((image, i) => {
      if (i === index) {
        image.classList.add("active");
      } else {
        image.classList.remove("active");
      }
    });
    this._syncTabSelection(index);
    if (this._isTabsImagTextSwiper2()) {
      this._buildTabsImagTextSwiper2FocusOrder();
    }
    if (this._isImageCardSwiper()) {
      this._syncImageCardSwiperLinkTabindex(index);
    }
    if (this.broImages.length > 0) {
      this.broImages.forEach((image, i) => {
        const video = image.querySelector(".slide-video");
        if (i === index) {
          image.classList.add("active");
          video && video.play();
        } else {
          image.classList.remove("active");
          video && video.pause();
        }
      });
    }
  }
};
if (!window.customElements.get("active-side")) {
  window.customElements.define("active-side", ActiveSide);
}
var ActiveSide2 = class extends HTMLElement {
  connectedCallback() {
    //console.log("ActiveSide");
    this.images = this.querySelectorAll(".color-swatch");
    this.images.forEach((image, index) => {
      image.setAttribute("tabindex", "0");
      image.setAttribute("role", "button");
      if (!image.getAttribute("aria-label")) {
        image.setAttribute("aria-label", `Color option ${index + 1}`);
      }
      const activate = this._onImageClick.bind(this, index);
      image.addEventListener("mouseover", activate);
      bindFocusActivate(image, activate);
      image.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          activate();
        }
      });
    });
    this.productImages = this.querySelectorAll(".slide-product-item");
    this.productImages2 = this.querySelectorAll(".slide-product-item2");
  }
  _onImageClick(index) {
    this.images.forEach((image, i) => {
      if (i === index) {
        image.classList.add("active");
      } else {
        image.classList.remove("active");
      }
    });
    if (this.productImages.length > 0) {
      this.productImages.forEach((image, i) => {
        if (i === index) {
          image.classList.add("active");
        } else {
          image.classList.remove("active");
        }
      });
    }
    if (this.productImages2.length > 0) {
      this.productImages2.forEach((image, i) => {
        const textContent = image.querySelector(".text-content-item");
        //console.log(textContent, "textContent");
        if (i === index) {
          image.classList.add("active");
        } else {
          image.classList.remove("active");
        }
      });
    }
  }
};
if (!window.customElements.get("active-side2")) {
  window.customElements.define("active-side2", ActiveSide2);
}
// js/sections/images-with-text-scrolling.js
import { animate as animate3, timeline as timeline5, inView as inView3 } from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
import { getHeadingKeyframe as getHeadingKeyframe2, throttle as throttle2 } from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var ImagesWithTextScrolling = class extends HTMLElement {
  connectedCallback() {
    inView3(this, this._reveal.bind(this));
    if (this.hasAttribute("scrolling-experience")) {
      this._imageToTransitionItems = Array.from(
        this.querySelectorAll(".images-scrolling-desktop__media-wrapper > :not(:first-child)"),
      );
      this._mainImage = this.querySelector(".images-scrolling-desktop__media-wrapper > :first-child");
      this._contentItems = Array.from(this.querySelectorAll(".images-scrolling__content"));
      if (this._imageToTransitionItems.length > 0) {
        window.addEventListener("scroll", throttle2(this._onScroll.bind(this)));
      }
    }
  }
  _reveal() {
    Array.from(this.querySelectorAll('[reveal-on-scroll="true"]')).forEach((heading) => {
      animate3(...getHeadingKeyframe2(heading));
    });
  }
  _onScroll() {
    const imageRect = this._mainImage.getBoundingClientRect(),
      imageBottom = imageRect.bottom,
      imageEffect = this.getAttribute("scrolling-experience");
    for (const [index, contentItem] of this._contentItems.entries()) {
      const contentItemRect = contentItem.getBoundingClientRect(),
        image = this._imageToTransitionItems[index - 1],
        content = this._contentItems[index];
      if (contentItemRect.top < imageBottom - imageRect.height * 0.15 && contentItemRect.bottom > imageBottom) {
        if (image && !image.classList.contains("is-visible")) {
          image.classList.add("is-visible");
          if (imageEffect === "fade") {
            timeline5([
              [image, { opacity: [null, 1] }, { duration: 0.2 }],
              [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }],
            ]);
          } else {
            timeline5([
              [
                image,
                { opacity: [null, 1], clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"] },
                { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } },
              ],
              [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }],
            ]);
          }
        }
        break;
      }
      if (contentItemRect.top > imageBottom - imageRect.height * 0.15) {
        if (image && image.classList.contains("is-visible")) {
          image.classList.remove("is-visible");
          if (imageEffect === "fade") {
            timeline5([
              [image, { opacity: [null, 0] }, { duration: 0.2 }],
              [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }],
            ]);
          } else {
            timeline5([
              [
                image,
                { opacity: [null, 1], clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"] },
                { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } },
              ],
              [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }],
            ]);
          }
        }
        break;
      }
    }
  }
};
if (!window.customElements.get("images-with-text-scrolling")) {
  window.customElements.define("images-with-text-scrolling", ImagesWithTextScrolling);
}

// js/sections/impact-text.js
import { animate as animate4, inView as inView4 } from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
var ImpactText = class extends HTMLElement {
  connectedCallback() {
    if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      return;
    }
    inView4(this, ({ target }) => this._onBecameVisible(target), { margin: "-100px" });
  }
  async _onBecameVisible(target) {
    animate4(target, { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 });
    if (this.hasAttribute("count-up")) {
      const itemToSearch = this.childElementCount === 0 ? this : this.firstElementChild,
        matches = itemToSearch.textContent.trim().match(/\d+(?:[,. ]\d+)*/);
      if (!matches) {
        return;
      }
      itemToSearch.innerHTML = itemToSearch.textContent.replace(/\d+(?:[,. ]\d+)*/, `<span>${matches[0]}</span>`);
      const numberSpan = itemToSearch.querySelector("span");
      numberSpan.style.textAlign = matches[0] === matches["input"] ? null : "end";
      if (!itemToSearch.classList.contains("text-gradient")) {
        numberSpan.style.display = "inline-block";
        numberSpan.style.minWidth = `${numberSpan.clientWidth}px`;
      }
      const toReplace = matches[0].replace(/[,\. ]+/, ""),
        charactersMatches = [...matches[0].matchAll(/[,\. ]+/g)];
      await animate4(
        (progress) => {
          let formattedString = Math.round(progress * parseInt(toReplace)).toString();
          charactersMatches.forEach((character) => {
            if (formattedString.length >= matches[0].length - character.index) {
              formattedString =
                formattedString.slice(0, character.index) + character[0] + formattedString.slice(character.index);
            }
          });
          numberSpan.textContent = progress === 1 ? matches[0] : formattedString;
        },
        { duration: parseFloat(this.getAttribute("count-up")), easing: [0.16, 1, 0.3, 1] },
      ).finished;
      numberSpan.style.minWidth = null;
    }
  }
};
if (!window.customElements.get("impact-text")) {
  window.customElements.define("impact-text", ImpactText);
}

// js/sections/media-grid.js
import { timeline as timeline6, inView as inView5 } from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
var MediaGrid = class extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.children);
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView5(this, this._onBecameVisible.bind(this));
    }
  }
  _onBecameVisible() {
    const contentElements = this.querySelectorAll(
      ".content-over-media > :not(img, video, iframe, svg, video-media, native-video, external-video)",
    );
    timeline6([
      [this.items, { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 }],
      [contentElements, { opacity: [0, 1] }, { duration: 0.2, at: "+0.1" }],
    ]);
  }
};
if (!window.customElements.get("media-grid")) {
  window.customElements.define("media-grid", MediaGrid);
}

// js/sections/media-with-text.js
import { animate as animate5, timeline as timeline7, inView as inView6 } from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
import { imageLoaded as imageLoaded2 } from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var MediaWithText = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      Array.from(this.querySelectorAll(".media-with-text__item")).forEach((item) => {
        inView6(item, (observer) => this.reveal(observer.target));
      });
    }
  }
  reveal(item) {
    const media = item.querySelector(".media-with-text__media");
    imageLoaded2(media.querySelector("img")).then(() => {
      timeline7([
        [media, { opacity: [0, 1] }, { duration: 0.3 }],
        [
          media.querySelector("img, video-media"),
          { transform: ["scale(1.05)", "scale(1)"] },
          { duration: 0.3, at: "<" },
        ],
      ]);
    });
    animate5(
      item.querySelector(".media-with-text__content > .prose"),
      { opacity: [0, 1] },
      { duration: 0.2, delay: 0.3 },
    );
  }
};
if (!window.customElements.get("media-with-text")) {
  window.customElements.define("media-with-text", MediaWithText);
}

// js/sections/multiple-images-with-text.js
import {
  timeline as timeline8,
  animate as animate6,
  stagger as stagger2,
  inView as inView7,
} from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
import {
  EffectCarousel as EffectCarousel3,
  imageLoaded as imageLoaded3,
  getHeadingKeyframe as getHeadingKeyframe3,
} from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var MultipleImagesWithText = class extends HTMLElement {
  constructor() {
    super();
    this._imageCarousel = this.querySelector("multiple-images-with-text-image-list");
    this._contentCarousel = this.querySelector("multiple-images-with-text-content-list");
    this.addEventListener("control:prev", () => {
      this._imageCarousel.previous();
      this._contentCarousel.previous();
    });
    this.addEventListener("control:next", () => {
      this._imageCarousel.next();
      this._contentCarousel.next();
    });
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => {
        if (event.target.hasAttribute("image-id")) {
          this._imageCarousel.select(
            this._imageCarousel.items.findIndex((item) => item.id === event.target.getAttribute("image-id")),
          );
        }
      });
    }
  }
};
var MultipleImagesWithTextImageList = class extends EffectCarousel3 {
  constructor() {
    super();
    inView7(this, this._reveal.bind(this));
  }
  async _reveal() {
    await imageLoaded3(this.querySelectorAll("img"));
    if (this.getAttribute("layout") === "stacked") {
      timeline8(
        [
          [this.lastElementChild, { transform: "rotate(0deg)" }],
          [this.lastElementChild?.previousElementSibling, { transform: "rotate(2deg)" }, { at: "<" }],
          [
            this.lastElementChild?.previousElementSibling?.previousElementSibling,
            { transform: "rotate(-2deg)" },
            { at: "<" },
          ],
        ],
        {
          defaultOptions: { duration: 0.15, easing: [0.26, 0.02, 0.27, 0.97] },
        },
      );
    } else if (this.getAttribute("layout") === "collage") {
      timeline8([
        [
          this.children,
          { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] },
          { duration: 0.3, delay: stagger2(0.1) },
        ],
      ]);
    } else {
      timeline8([
        [
          this.children,
          { opacity: 1, transform: "rotate(var(--image-rotation, 0deg))" },
          { duration: 0.3, delay: stagger2(0.1) },
        ],
      ]);
    }
  }
  _transitionTo(fromSlide, toSlide, { direction, animate: animate8 }) {
    if (this.getAttribute("layout") !== "stacked") {
      return;
    }
    const transitionSpeed = 0.2;
    if (direction === "next") {
      const fromSlideTransform = getComputedStyle(fromSlide).getPropertyValue("transform");
      return timeline8(
        [
          [fromSlide, { opacity: 0, transform: "rotate(5deg) translate(40px, 10px)" }, { duration: transitionSpeed }],
          [toSlide, { zIndex: 1 }, { duration: transitionSpeed, zIndex: { easing: "step-start" } }],
          [
            fromSlide,
            { opacity: 1, transform: fromSlideTransform, zIndex: -1 },
            { duration: transitionSpeed, at: "<", zIndex: { easing: "step-start" } },
          ],
          [toSlide.previousElementSibling, { zIndex: 0 }, { at: "<", easing: "step-start" }],
        ],
        { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } },
      ).finished;
    } else {
      const toSlideTransform = getComputedStyle(toSlide).getPropertyValue("transform");
      return timeline8(
        [
          [toSlide, { opacity: 0, transform: "rotate(-5deg) translate(-40px, -10px)" }, { duration: transitionSpeed }],
          this.items.length >= 3 && [
            fromSlide.previousElementSibling || this.lastElementChild,
            { zIndex: -1 },
            { easing: "step-start" },
          ],
          [
            toSlide,
            { opacity: 1, transform: toSlideTransform, zIndex: 1 },
            { duration: transitionSpeed, at: this.items.length >= 3 ? "<" : "+0", zIndex: { easing: "step-start" } },
          ],
          [fromSlide, { zIndex: 0 }, { duration: transitionSpeed, at: "<", zIndex: { easing: "step-start" } }],
        ].filter(Boolean),
        { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } },
      ).finished;
    }
  }
};
var MultipleImagesWithTextContentList = class extends EffectCarousel3 {
  constructor() {
    super();
    inView7(this, this._reveal.bind(this));
  }
  _reveal() {
    animate6(...getHeadingKeyframe3(this.querySelector('[reveal-on-scroll="true"]')));
  }
  _transitionTo(fromSlide, toSlide, { direction = "next", animate: animate8 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    return timeline8(
      [
        [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"] }],
        [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"] }],
        [...getHeadingKeyframe3(toSlide.querySelector('[reveal-on-scroll="true"]'), { at: "<" })],
      ],
      { duration: animate8 ? parseFloat(this.getAttribute("fade-speed") || 0.5) : 0 },
    ).finished;
  }
};
if (!window.customElements.get("multiple-images-with-text")) {
  window.customElements.define("multiple-images-with-text", MultipleImagesWithText);
}
if (!window.customElements.get("multiple-images-with-text-image-list")) {
  window.customElements.define("multiple-images-with-text-image-list", MultipleImagesWithTextImageList);
}
if (!window.customElements.get("multiple-images-with-text-content-list")) {
  window.customElements.define("multiple-images-with-text-content-list", MultipleImagesWithTextContentList);
}

// js/sections/newsletter-popup.js
import { Drawer as Drawer2 } from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var NewsletterPopup = class extends Drawer2 {
  connectedCallback() {
    super.connectedCallback();
    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }
  get initialFocus() {
    return false;
  }
  get shouldAppendToBody() {
    return false;
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get shouldAppearAutomatically() {
    return !(
      localStorage.getItem("theme:popup-filled") === "true" ||
      (this.hasAttribute("only-once") && localStorage.getItem("theme:popup-appeared") === "true")
    );
  }
  _setInitialPosition() {
    this.style.top = null;
    this.style.bottom = "0px";
    this.style.left = document.dir === "ltr" ? null : "0px";
    this.style.right = document.dir === "rtl" ? "auto" : "0px";
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:popup-appeared", "true");
    }
  }
};
if (!window.customElements.get("newsletter-popup")) {
  window.customElements.define("newsletter-popup", NewsletterPopup);
}

// js/sections/press.js
import { timeline as timeline9, animate as animate7, inView as inView8 } from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
import { EffectCarousel as EffectCarousel4 } from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var reduceMotion2 = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var PressCarousel = class extends EffectCarousel4 {
  constructor() {
    super();
    if (reduceMotion2) {
      inView8(this, this._reveal.bind(this));
    }
  }
  _reveal() {
    animate7(
      this.selectedSlide.querySelector(".blockquote"),
      { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] },
      { duration: 0.2 },
    );
  }
  async _transitionTo(fromSlide, toSlide, options = {}) {
    await timeline9([
      [fromSlide.querySelectorAll(".press__logo, .press__author"), { opacity: [null, 0] }, { duration: 0.2 }],
      [
        fromSlide.querySelector(".blockquote"),
        { opacity: [null, 0], ...(reduceMotion2 && { transform: [null, "translateY(-10px)"] }) },
        { duration: 0.2, at: "<" },
      ],
    ]).finished;
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    await timeline9([
      [toSlide.querySelectorAll(".press__logo, .press__author"), { opacity: [0, 1] }, { duration: 0.2 }],
      [
        toSlide.querySelector(".blockquote"),
        { opacity: [0, 1], ...(reduceMotion2 && { transform: ["translateY(10px)", "translateY(0px)"] }) },
        { duration: 0.2, at: "<" },
      ],
    ]).finished;
  }
};
if (!window.customElements.get("press-carousel")) {
  window.customElements.define("press-carousel", PressCarousel);
}

// js/sections/product-recommendations.js
var ProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
  }
  connectedCallback() {
    this._loadRecommendations();
  }
  async _loadRecommendations() {
    if (this._isLoaded) {
      return;
    }
    this._isLoaded = true;
    const section = this.closest(".shopify-section"),
      intent = this.getAttribute("intent") || "related",
      url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${
        this.getAttribute("limit") || 4
      }&section_id=${section.id.replace("shopify-section-", "")}&intent=${intent}`,
      response = await fetch(url, { priority: "low" });
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"),
      productRecommendationsElement = tempDiv.querySelector("product-recommendations");
    if (productRecommendationsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
    } else {
      if (intent === "related") {
        section.remove();
      } else {
        this.remove();
      }
    }
  }
};
if (!window.customElements.get("product-recommendations")) {
  window.customElements.define("product-recommendations", ProductRecommendations);
}

// js/sections/recently-viewed-products.js
import { extractSectionId } from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var _isLoaded, _searchQueryString, searchQueryString_get, _loadProducts, loadProducts_fn;
var RecentlyViewedProducts = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _searchQueryString);
    __privateAdd(this, _loadProducts);
    __privateAdd(this, _isLoaded, false);
  }
  connectedCallback() {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(__privateMethod(this, _loadProducts, loadProducts_fn).bind(this), { timeout: 1500 });
    } else {
      __privateMethod(this, _loadProducts, loadProducts_fn).call(this);
    }
  }
};
_isLoaded = new WeakMap();
_searchQueryString = new WeakSet();
searchQueryString_get = function () {
  const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
  if (this.hasAttribute("exclude-id")) {
    items.delete(parseInt(this.getAttribute("exclude-id")));
  }
  return Array.from(items.values(), (item) => `id:${item}`)
    .slice(0, parseInt(this.getAttribute("products-count")))
    .join(" OR ");
};
_loadProducts = new WeakSet();
loadProducts_fn = async function () {
  if (__privateGet(this, _isLoaded)) {
    return;
  }
  __privateSet(this, _isLoaded, true);
  const section = this.closest(".shopify-section"),
    url = `${Shopify.routes.root}search?type=product&q=${__privateGet(
      this,
      _searchQueryString,
      searchQueryString_get,
    )}&section_id=${extractSectionId(section)}`,
    response = await fetch(url, { priority: "low" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"),
    recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
  if (recentlyViewedProductsElement.childElementCount > 0) {
    this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
  } else {
    section.remove();
  }
};
if (!window.customElements.get("recently-viewed-products")) {
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}

// js/sections/revealed-image-on-scroll.js
import {
  scroll as scroll3,
  timeline as timeline10,
  ScrollOffset,
  inView as inView9,
} from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
var RevealedImage = class extends HTMLElement {
  connectedCallback() {
    const scrollTracker = this.querySelector(".revealed-image__scroll-tracker"),
      scroller = this.querySelector(".revealed-image__scroller");
    scrollTracker.style.height = `${scroller.clientHeight}px`;
    new ResizeObserver((entries) => (scrollTracker.style.height = `${entries[0].contentRect.height}px`)).observe(
      scroller,
    );
    scroll3(
      timeline10([
        [
          this.querySelectorAll(".revealed-image__image-clipper, .revealed-image__content--inside"),
          { clipPath: ["inset(37% 37% 41% 37%)", "inset(calc(var(--sticky-area-height) / 2) 0)"] },
          { easing: "ease-in" },
        ],
        [
          this.querySelectorAll("img, svg"),
          { transform: ["translate(-10%, -1.5%) scale(1.4)", "translate(0, 0) scale(1)"] },
          { easing: "ease-in", at: "<" },
        ],
        [this.querySelectorAll(".revealed-image__content"), { opacity: [0, 1, 1] }, { offset: [0, 0.25, 1], at: "<" }],
      ]),
      {
        target: scrollTracker,
        offset: ScrollOffset.All,
      },
    );
    inView9(
      this,
      () => {
        this.style.visibility = "visible";
        return () => {
          this.style.visibility = "hidden";
        };
      },
      { margin: "200px" },
    );
  }
};
if (!window.customElements.get("revealed-image")) {
  window.customElements.define("revealed-image", RevealedImage);
}

// js/sections/shop-the-look.js
var ShopTheLookDots = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    Array.from(this.children).forEach((dots) => {
      document
        .getElementById(dots.getAttribute("aria-controls"))
        .addEventListener("carousel:change", (event) => this._onDotClicked(event), {
          signal: this._abortController.signal,
        });
    });
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  _onDotClicked(event) {
    Array.from(this.querySelectorAll(`button:nth-child(${event.detail.index + 1})`)).forEach((button) =>
      button.click(),
    );
  }
};
if (!window.customElements.get("shop-the-look-dots")) {
  window.customElements.define("shop-the-look-dots", ShopTheLookDots);
}

// js/sections/slideshow.js
import {
  animate as motionAnimate2,
  timeline as timeline11,
  inView as inView10,
} from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
import {
  EffectCarousel as EffectCarousel5,
  imageLoaded as imageLoaded4,
  getHeadingKeyframe as getHeadingKeyframe4,
} from "//ringconn.com/cdn/shop/t/270/assets/theme.js?v=1862815097554241761792467208";
var Slideshow = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("carousel:select", this._onSlideSelected);
  }
  async _onSlideSelected(event) {
    const slideStyles = getComputedStyle(event.detail.slide);
    this.style.setProperty(
      "--slideshow-controls-background",
      slideStyles.getPropertyValue("--slideshow-slide-controls-background"),
    );
    this.style.setProperty(
      "--slideshow-controls-color",
      slideStyles.getPropertyValue("--slideshow-slide-controls-color"),
    );
    if (!this.classList.contains("slideshow--boxed")) {
      return;
    }
    const backgroundElement = this.querySelector(".slideshow__slide-background");
    const background = slideStyles.getPropertyValue("--slideshow-slide-background");
    backgroundElement.style.background = background;
    await motionAnimate2(backgroundElement, { opacity: [0, 1] }, { duration: 0.2 }).finished;
    this.style.setProperty("--slideshow-background", background);
    motionAnimate2(backgroundElement, { opacity: 0 }, { duration: 0 });
  }
};
var SlideshowCarousel = class extends EffectCarousel5 {
  constructor() {
    super();
    inView10(this, this._reveal.bind(this));
    if (this.querySelector(".slideshow__cursor")) {
      this.addEventListener("tap", this._onSlideshowTap);
    }
  }
  connectedCallback() {
    super.connectedCallback();
    if (this._player && this.hasAttribute("autoplay")) {
      this._player.addEventListener("player:start", () => {
        const cursorRing = this.querySelector(".slideshow__cursor-ring circle");
        if (cursorRing) {
          motionAnimate2(
            cursorRing,
            {
              strokeDasharray: [
                `0px, ${cursorRing.getTotalLength()}px`,
                `${cursorRing.getTotalLength()}px, ${cursorRing.getTotalLength()}px`,
              ],
            },
            {
              duration: parseInt(this.getAttribute("autoplay")),
              easing: "linear",
            },
          );
        }
        const circles = Array.from(this.querySelectorAll(".numbered-dots__item"));
        circles.forEach((item) => {
          const circle = item.querySelector("circle:last-child");
          if (item.getAttribute("aria-current") === "true") {
            motionAnimate2(
              circle,
              {
                strokeDasharray: [
                  `0px, ${circle.getTotalLength()}px`,
                  `${circle.getTotalLength()}px, ${circle.getTotalLength()}px`,
                ],
              },
              { duration: parseInt(this.getAttribute("autoplay")), easing: "linear" },
            );
          } else {
            motionAnimate2(
              circle,
              { strokeDasharray: `${circle.getTotalLength()}px, ${circle.getTotalLength()}px` },
              { duration: 0, easing: "linear" },
            );
          }
        });
      });
    }
  }
  get transitionType() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "fade" : this.getAttribute("transition");
  }
  async _reveal() {
    const selectedSlide = this.selectedSlide;
    await imageLoaded4(selectedSlide.querySelectorAll("img"));
    this.style.opacity = "1";
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }
    if (!this._reloaded) {
      timeline11([
        [selectedSlide, { zIndex: 0 }, { duration: 0 }],
        [
          selectedSlide.querySelectorAll("img"),
          { opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] },
          { duration: 0.3 },
        ],
        "content",
        [
          selectedSlide.querySelectorAll('[data-sequence="subheading"], .button'),
          { opacity: [0, 1] },
          { duration: 0.3, at: "content" },
        ],
        [
          ...getHeadingKeyframe4(selectedSlide.querySelector('[data-sequence="heading"]'), {
            duration: 0.3,
            at: "content",
          }),
        ],
        [selectedSlide.querySelector(".button"), { opacity: [0, 1] }, { duration: 0.3, at: "content" }],
        [
          this.querySelector(".slideshow__controls"),
          { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] },
          { duration: 0.3 },
        ],
      ]);
    }
  }
  _onSlideshowTap(event) {
    if (
      event.target.matches("button, a[href], button :scope, a[href] :scope") ||
      !window.matchMedia("screen and (pointer: fine)").matches
    ) {
      return;
    }
    event.detail.originalEvent.clientX > window.innerWidth / 2 ? this.next() : this.previous();
  }
  /**
   * Perform a simple fade animation. For more complex animations, you should implement your own custom elements
   * that extends the EffectCarousel, and implement your own transition. You should make sure to return a promise
   * that resolves when the animation is finished
   */
  async _transitionTo(fromSlide, toSlide, { direction, animate: animate8 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    let timelineControls = null;
    switch (this.transitionType) {
      case "fade":
        timelineControls = this._fade(fromSlide, toSlide, { animate: animate8 });
        break;
      case "fade_with_text":
        timelineControls = this._fadeWithText(fromSlide, toSlide, { animate: animate8 });
        break;
    }
    if (!animate8) {
      timelineControls.finish();
    }
    return timelineControls.finished;
  }
  /**
   * Perform a simple fade transition
   */
  _fade(fromSlide, toSlide) {
    return timeline11([
      [
        fromSlide,
        { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: -1 },
        { duration: 0.3, easing: "ease-in", zIndex: { easing: "step-end" } },
      ],
      [
        toSlide,
        { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 0 },
        { duration: 0.3, at: "<", easing: "ease-out", zIndex: { easing: "step-end" } },
      ],
    ]);
  }
  /**
   * Perform a transition with fade images and image transition
   */
  async _fadeWithText(fromSlide, toSlide) {
    motionAnimate2(
      fromSlide,
      { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: -1 },
      { duration: 0.3, easing: "ease-in", zIndex: { easing: "step-end" } },
    );
    await imageLoaded4(toSlide.querySelectorAll("img"));
    motionAnimate2(
      toSlide,
      { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 0 },
      { duration: 0, zIndex: { easing: "step-end" } },
    );
    return timeline11([
      [
        toSlide.querySelectorAll("img"),
        { opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] },
        { duration: 0.3, easing: "ease-out" },
      ],
      "content",
      [
        toSlide.querySelectorAll('[data-sequence="subheading"], .button'),
        { opacity: [0, 1] },
        { duration: 0.3, at: "content" },
      ],
      [...getHeadingKeyframe4(toSlide.querySelector('[data-sequence="heading"]'), { duration: 0.3, at: "content" })],
    ]);
  }
};
if (!window.customElements.get("x-slideshow")) {
  window.customElements.define("x-slideshow", Slideshow);
}
if (!window.customElements.get("slideshow-carousel")) {
  window.customElements.define("slideshow-carousel", SlideshowCarousel);
}
// position-text
var PositionTexts = class extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.positionTexts = this.querySelectorAll(".position-text");
    this.positionTexts.forEach((item) => {
      const positionIcon = item.querySelector(".animated-arrow");
      item.addEventListener("click", this.onPositionTextActivate.bind(this));
      positionIcon?.addEventListener("click", this.onPositionArrowClick.bind(this));
      item.addEventListener("keydown", this.onPositionTextKeydown.bind(this));
    });
  }
  getPositionTextItem(target) {
    return target?.closest?.(".position-text");
  }
  onPositionTextActivate(event) {
    if (event.target.closest(".animated-arrow")) {
      return;
    }
    const item = this.getPositionTextItem(event.target);
    if (!item) {
      return;
    }
    if (item.matches("a[href]")) {
      event.preventDefault();
    }
    this.scrollPositionTextIntoView(item);
  }
  onPositionArrowClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.showDropdown(event);
  }
  onPositionTextKeydown(event) {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }
    const item = this.getPositionTextItem(event.target);
    if (!item?.classList.contains("position-text--action")) {
      return;
    }
    event.preventDefault();
    if (event.target.closest(".animated-arrow")) {
      this.showDropdown(event);
      return;
    }
    this.scrollPositionTextIntoView(item);
  }
  scrollPositionTextIntoView(item) {
    const id = item?.getAttribute("data-position-text-id");
    if (!id) {
      return;
    }
    const element = document.getElementById(id);
    if (!element) {
      return;
    }
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  scrollIntoView(event) {
    this.scrollPositionTextIntoView(this.getPositionTextItem(event.target));
  }
  showDropdown(event) {
    const arrow = event.target.closest(".animated-arrow") || event.target;
    if (arrow.classList.contains("active")) {
      arrow.classList.remove("active");
      this.flexNone("none");
    } else {
      arrow.classList.add("active");
      this.flexNone("flex");
    }
  }
  flexNone(type = "flex") {
    this.positionTexts.forEach((item) => {
      const index = item.getAttribute("index");
      if (index != 0) {
        item.style.display = type;
      }
    });
  }
};
if (!window.customElements.get("position-texts")) {
  window.customElements.define("position-texts", PositionTexts);
}
// js/sections/register-custom.js
// 注册页面
var RegisterCustom = class extends HTMLElement {
  connectedCallback() {
    this._init();
    this.form.addEventListener("submit", (e) => this._custom_submit(e));
    this.email.addEventListener("blur", (e) => this._email_change(e));
    this.password.addEventListener("blur", (e) => this._password_change(e));
    this.disabledButtonContainer.addEventListener("click", (e) => this._custom_submit2(e));
  }

  _init() {
    // 获取DOM元素
    this.form = this.querySelector('form[action="/account"]');
    this.email = this.form.querySelector('input[name="customer[email]"]');
    this.password = this.form.querySelector('input[name="customer[password]"]');
    this.errorBanner =
      this.form.querySelector('[data-banner-type="error"]') || this.form.querySelector(".banner-error");
    this.disabledButtonContainer = this.form.querySelector(".disabled-button");
    this.registerButtonContainer = this.form.querySelector(".register-button");
    this.emailErrorContainer = this.form.querySelector(".email_error");
    this.passwordErrorContainer = this.form.querySelector(".password_error");
    this.submitButton = this.querySelector('button[type="submit"]');
    this.termsError = this.querySelector(".termsError");
    this.termsErrorContainer = this.querySelector(".termsError .reset-content ");
    // 初始化变量
    this.emailValue = "";
    this.passwordValue = "";
    this.emailError = false;
    this.passwordError = false;
  }

  // 自定义提交
  async _custom_submit(e) {
    e.preventDefault();
    //console.log(this.password.getAttribute("data-md5"), "md5");
    if (this._validate_form()) {
      // 创建自定义事件
      const payload = {
        email: this.emailValue,
        password: this.password.getAttribute("data-md5"),
        name: this.form.querySelector('input[name="customer[first_name]"]').value,
        webSite: window.ShopifyInfo.webSite || "GB",
      };
      this._handleBeforeSubmit({ payload });
      // 提交表单
      // this.form.submit();
    }
  }
  _custom_submit2(e) {
    this.emailError = !this._validate_email(this.emailValue);
    this.passwordError = !this._check_password(this.passwordValue);
    this._update_errors();
  }
  _validate_email(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }
  async _handleBeforeSubmit(data) {
    //console.log(data, "data");
    data.client = { languageCode: window?.ShopifyInfo?.language || "en" };
    this.submitButton.setAttribute("disabled", true);
    const url = window.ShopifyInfo.baseUrl;
    const response = await fetch(`${url}/admin/ringconn/UserRegister`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const res = await response.json();
    if (res.code == 0) {
      this.form.submit();
    } else {
      this.termsError.style.display = "block";
      this.termsErrorContainer.innerHTML = res?.msg;
      setTimeout(() => {
        this.termsError.style.display = "none";
      }, 3000);
      this.submitButton.setAttribute("disabled", false);
      this.submitButton.removeAttribute("aria-busy", false);
    }

    //console.log(res, "res");
  }

  _check_password(password) {
    // 密码长度为 8 - 20 个字符，且至少包含一个数字、一个大写字母和一个小写字母
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,20}$/;
    return regex.test(password);
  }

  _validate_form() {
    if (!this.emailError && !this.passwordError) {
      this._update_errors();
      return true;
    }
    return false;
  }
  _change_register_button() {
    if (!this._validate_form()) {
      this.disabledButtonContainer.style.display = "block";
      this.registerButtonContainer.style.display = "none";
    } else {
      this.disabledButtonContainer.style.display = "none";
      this.registerButtonContainer.style.display = "block";
    }
  }

  _clear_errors() {
    this.emailErrorContainer.style.display = "none";
    this.passwordErrorContainer.style.color = "#666666";
  }

  _update_errors() {
    //console.log("_update_errors");
    this._clear_errors();
    if (this.emailError) this.emailErrorContainer.style.display = "block";
    if (this.passwordError) this.passwordErrorContainer.style.color = "#ff0000";
  }
  _;
  _email_change(e) {
    this.emailValue = e.target.value;
    this.emailError = !this._validate_email(this.emailValue);
    this._update_errors();
    this._change_register_button();
  }

  _password_change(e) {
    this.passwordValue = e.target.value;
    const md5Value = this._calculate_md5(e.target.value);
    //console.log(md5Value, "md5Value2", e.target.value);
    if (md5Value) {
      //console.log(md5Value, "md5Value", e.target.value);
      this.password.setAttribute("data-md5", md5Value);
    }
    this.passwordError = !this._check_password(this.passwordValue);
    this._update_errors();
    this._change_register_button();
  }
  _calculate_md5(value) {
    if (!value) return null;
    // 这里使用 CryptoJS 库来计算 md5
    if (typeof CryptoJS !== "undefined") {
      return CryptoJS.MD5(value).toString();
    }
    return null;
  }
};
if (!window.customElements.get("register-custom")) {
  window.customElements.define("register-custom", RegisterCustom);
}

// js/sections/reset-password-custom.js
// 重置密码
var ResetPasswordCustom = class extends HTMLElement {
  connectedCallback() {
    this._init();
    this.form.addEventListener("submit", (e) => this._custom_submit(e));
    this.password.addEventListener("blur", (e) => this._password_change(e));
    this.passwordCondirm.addEventListener("blur", (e) => this._password_confirm_change(e));
    this.password.addEventListener("input", (e) => this._input_password_error_change(e));
    this.passwordCondirm.addEventListener("input", (e) => this._input_confirm_password_error_change(e));
  }

  _init() {
    // 获取一些dom元素
    this.form = this.querySelector('form[action="/account/reset"]');
    this.password = this.form.querySelector('input[name="customer[password]"]');
    this.passwordCondirm = this.form.querySelector('input[name="customer[password_confirmation]"]');
    this.errorBanner =
      this.form.querySelector('[data-banner-type="error"]') || this.form.querySelector(".banner-error");
    this.disabledButtonContainer = this.form.querySelector(".disabled-button");
    this.resetButtonContainer = this.form.querySelector(".reset-button");
    this.confirmErrorContainer = this.form.querySelector(".confirm_error");
    this.passwordAndConfirmErrorContainer = this.form.querySelector(".password_and_confirm_error");
    this.passwordErrorContainer = this.form.querySelector(".password_error");
    // 初始化变量
    this.passwordValue = "";
    this.passwordConfirmValue = "";
    this.passwordError = false;
    this.confirmPasswordError = false;
    this.inputErrorOk = true;
  }

  // 自定义提交
  async _custom_submit(e) {
    e.preventDefault();
    this.form.submit();
  }

  // _get_id() {
  //   const regex = /\/reset\/(\d+)\//;
  //   const match = window.location.href.match(regex);
  //   if (match && match.length > 1) {
  //     const targetNumber = match[1];
  //     return targetNumber;
  //   }
  //   return "";
  // }

  _check_password(password) {
    // 密码长度为 8 - 20 个字符，且至少包含一个数字、一个大写字母和一个小写字母
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,20}$/;
    return regex.test(password);
  }

  // 检查密码和确认密码是否一致
  _check_confirm_password() {
    return this.passwordValue === this.passwordConfirmValue;
  }

  // 切换提交按钮样式
  _change_reset_button() {
    if (this.passwordError || !this._check_confirm_password()) {
      this.disabledButtonContainer.style.display = "block";
      this.resetButtonContainer.style.display = "none";
    } else {
      this.disabledButtonContainer.style.display = "none";
      this.resetButtonContainer.style.display = "block";
    }
  }

  // 清除错误弹窗
  _clear_error() {
    this.passwordAndConfirmErrorContainer.style.display = "none";
    this.passwordErrorContainer.style.display = "none";
    this.confirmErrorContainer.style.display = "none";
  }

  // 弹出不同错误
  _change_error_message() {
    if (this.passwordError && this.confirmPasswordError) this.passwordAndConfirmErrorContainer.style.display = "block";
    if (this.passwordError && !this.confirmPasswordError) this.passwordErrorContainer.style.display = "block";
    if (!this.passwordError && this.confirmPasswordError) this.confirmErrorContainer.style.display = "block";
  }

  _update_error_ok() {
    this.inputErrorOk = !this.passwordError && !this.confirmPasswordError;
  }

  _password_change(e) {
    this.passwordValue = e.target.value;
    this._check_fn();
    this._update_error_ok();
    this._change_reset_button();
    this._clear_error();
    this._change_error_message();
  }

  _password_confirm_change(e) {
    this.passwordConfirmValue = e.target.value;
    this._check_fn();
    this._update_error_ok();
    this._change_reset_button();
    this._clear_error();
    this._change_error_message();
  }

  _input_password_error_change(e) {
    if (this.inputErrorOk) return;
    this.passwordValue = e.target.value;
    this._check_fn();
    this._update_error_ok();
    this._clear_error();
    this._change_error_message();
  }

  _check_fn() {
    this.confirmPasswordError = !this._check_confirm_password();
    this.passwordError = !this._check_password(this.passwordConfirmValue) || !this._check_password(this.passwordValue);
  }

  _input_confirm_password_error_change(e) {
    if (this.inputErrorOk) return;
    this.passwordConfirmValue = e.target.value;
    this._check_fn();
    this._update_error_ok();
    this._clear_error();
    this._change_error_message();
  }
};
if (!window.customElements.get("reset-password-custom")) {
  window.customElements.define("reset-password-custom", ResetPasswordCustom);
}
import {
  animate as animate9,
  timeline as timeline12,
  inView as inView12,
  scroll as scroll12,
} from "//ringconn.com/cdn/shop/t/270/assets/vendor.min.js?v=110209841862038618801792466870";
var GradualText = class extends HTMLElement {
  connectedCallback() {
    this._init();
  }

  _init() {
    // 获取配置参数
    const BlockTitle = this.querySelector(".gradual-heading-first");
    const BlockText = this.querySelector(".gradual-heading-last");
    //console.log(this.dataset.type, "this.dataset.type");
    const firstElement = this.dataset.type == "H2" ? BlockTitle : BlockText;
    const lastElement = this.dataset.type != "H2" ? BlockTitle : BlockText;
    const central = this.dataset.centralProportion + "%";
    //console.log(firstElement, lastElement, "firstElement", central);
    // 使用 inView12 监听元素是否在扩展视口范围内
    // 当元素完全离开视口时，确保透明度为 0
    this._inViewInstance = inView12(
      this,
      (info) => {
        //console.log(info, "info", firstElement, lastElement);
        if (info.isIntersecting & !info.hasAnimated) {
          // 第一个元素淡出

          setTimeout(() => {
            animate9(
              firstElement,
              { opacity: [1, 0] },
              {
                duration: 1,
                easing: "ease-out",
              },
            );
          }, 3500);

          // 第二个元素淡入（延迟一点）
          setTimeout(() => {
            animate9(
              lastElement,
              { opacity: [0, 1] },
              {
                duration: 1,
                easing: "ease-in",
              },
            );
          }, 4000);
        }
      },
      {
        // 扩大检测范围，提前检测元素进入
        margin: "-40% 0px -40% 0px",
      },
    );
  }

  disconnectedCallback() {
    // 清理所有监听器

    if (this._inViewInstance && typeof this._inViewInstance === "function") {
      this._inViewInstance();
    }
  }
};

if (!window.customElements.get("gradual-text")) {
  window.customElements.define("gradual-text", GradualText);
}

// 检查 crypto-js 是否存在
document.addEventListener("DOMContentLoaded", function () {
  // 给 CryptoJS 一点时间加载
  setTimeout(function () {
    if (typeof CryptoJS === "undefined") {
      // 首先尝试加载本地文件
      const localScript = document.createElement("script");
      localScript.src = "//ringconn.com/cdn/shop/t/270/assets/crypto-js.min.js?v=122004714028331818701792467207";
      localScript.onload = function () {
        //console.log("Local CryptoJS loaded successfully");
      };
      localScript.onerror = function () {
        console.warn("Local CryptoJS failed, trying CDN...");
        // 如果本地加载失败，尝试加载 CDN 版本
        const cdnScript = document.createElement("script");
        cdnScript.src = "https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js";
        cdnScript.onload = function () {
          //console.log("CDN CryptoJS loaded successfully");
        };
        cdnScript.onerror = function () {
          console.error("Failed to load CryptoJS from both local and CDN");
        };
        document.head.appendChild(cdnScript);
      };
      document.head.appendChild(localScript);
    }
  }, 1000); // 等待1秒后检查
});

if (!window?.ShopifyInfo) {
  let shopDomain = "";
  let Environment = {
    "ringconntest.myshopify.com": "GB|en",
    "ringconn.com": "GB|en",
    "de.ringconn.com": "DE|de",
    "ringconn.jp": "JP|ja",
  };
  const siteLanguage = Environment[shopDomain].split("|");
  let webSite = siteLanguage[0] || "GB";
  let language = siteLanguage[1] || "en";

  window.ShopifyInfo = {
    shopDomain: shopDomain,
    webSite: webSite,
    baseUrl: shopDomain.includes("test") ? "https://dev.oms.gdjztech.com" : "https://oms.gdjztech.com",
    language,
  };
}
